var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fluid" },
    [
      _c("br"),
      _c(
        "h2",
        { staticClass: "app-title" },
        [
          _c("b-form-group", { staticClass: "text-label" }, [
            _c("label", { ref: "cpf", attrs: { tabindex: "0" } }, [
              _c("legend", [
                _vm._v("Lei Brasileira de Inclusão (Lei Federal nº 13146/2015)")
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "A PRESIDENTA DA REPÚBLICA Faço saber que o Congresso Nacional decreta e eu sanciono a seguinte Lei:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("LIVRO I")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("PARTE GERAL")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("TÍTULO I")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DISPOSIÇÕES PRELIMINARES")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("CAPÍTULO I")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("ISPOSIÇÕES GERAIS")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1º\tÉ instituída a Lei Brasileira de Inclusão da Pessoa com Deficiência\n\t\t\t\t(Estatuto da Pessoa com Deficiência), destinada a assegurar e a\n\t\t\t\tpromover, em condições de igualdade, o exercício dos direitos e das\n\t\t\t\tliberdades fundamentais por pessoa com deficiência, visando à sua\n\t\t\t\tinclusão social e cidadania."
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Parágrafo único. Esta Lei tem como base a\n\t\t\t\tConvenção sobre os Direitos das Pessoas com Deficiência e seu Protocolo\n\t\t\t\tFacultativo, ratificados pelo Congresso Nacional por meio do Decreto\n\t\t\t\tLegislativo nº 186, de 9 de julho de 2008 , em conformidade com o\n\t\t\t\tprocedimento previsto no § 3º do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 5º da Constituição da República\n\t\t\t\tFederativa do Brasil , em vigor para o Brasil, no plano jurídico\n\t\t\t\texterno, desde 31 de agosto de 2008, e promulgados pelo Decreto nº\n\t\t\t\t6.949, de 25 de agosto de 2009 , data de início de sua vigência no plano\n\t\t\t\tinterno. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 2º Considera-se pessoa com deficiência aquela que tem\n\t\t\t\timpedimento de longo prazo de natureza física, mental, intelectual ou\n\t\t\t\tsensorial, o qual, em interação com uma ou mais barreiras, pode obstruir\n\t\t\t\tsua participação plena e efetiva na sociedade em igualdade de condições\n\t\t\t\tcom as demais pessoas."
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "§ 1º A avaliação da deficiência, quando\n\t\t\t\tnecessária, será biopsicossocial, realizada por equipe multiprofissional\n\t\t\t\te interdisciplinar e considerará: (Vigência) (Vide Decreto nº 11.063, de\n\t\t\t\t2022)"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "I - os impedimentos nas funções e nas estruturas do corpo;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "II - os fatores socioambientais, psicológicos e pessoais;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "III - a limitação no\n\t\t\t\tdesempenho de atividades; e"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("IV - a restrição de participação.")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "§ 2º O\n\t\t\t\tPoder Executivo criará instrumentos para avaliação da deficiência. (Vide\n\t\t\t\tLei nº 13.846, de 2019) (Vide Lei nº 14.126, de 2021)"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 2º-A. É\n\t\t\t\tinstituído o cordão de fita com desenhos de girassóis como símbolo\n\t\t\t\tnacional de identificação de pessoas com deficiências ocultas. (Incluído\n\t\t\t\tpela Lei nº 14.624, de 2023) § 1º O uso do símbolo de que trata o caput\n\t\t\t\tdeste artigo é opcional, e sua ausência não prejudica o exercício de\n\t\t\t\tdireitos e garantias previstos em lei. (Incluído pela Lei nº 14.624, de\n\t\t\t\t2023) § 2º A utilização do símbolo de que trata o caput deste artigo não\n\t\t\t\tdispensa a apresentação de documento comprobatório da deficiência, caso\n\t\t\t\tseja solicitado pelo atendente ou pela autoridade competente. (Incluído\n\t\t\t\tpela Lei nº 14.624, de 2023) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 3º Para fins de aplicação desta Lei,\n\t\t\t\tconsideram-se:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - acessibilidade: possibilidade e condição de alcance\n\t\t\t\tpara utilização, com segurança e autonomia, de espaços, mobiliários,\n\t\t\t\tequipamentos urbanos, edificações, transportes, informação e\n\t\t\t\tcomunicação, inclusive seus sistemas e tecnologias, bem como de outros\n\t\t\t\tserviços e instalações abertos ao público, de uso público ou privados de\n\t\t\t\tuso coletivo, tanto na zona urbana como na rural, por pessoa com\n\t\t\t\tdeficiência ou com mobilidade reduzida;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - desenho universal:\n\t\t\t\tconcepção de produtos, ambientes, programas e serviços a serem usados\n\t\t\t\tpor todas as pessoas, sem necessidade de adaptação ou de projeto\n\t\t\t\tespecífico, incluindo os recursos de tecnologia assistiva; III -\n\t\t\t\ttecnologia assistiva ou ajuda técnica: produtos, equipamentos,\n\t\t\t\tdispositivos, recursos, metodologias, estratégias, práticas e serviços\n\t\t\t\tque objetivem promover a funcionalidade, relacionada à atividade e à\n\t\t\t\tparticipação da pessoa com deficiência ou com mobilidade reduzida,\n\t\t\t\tvisando à sua autonomia, independência, qualidade de vida e inclusão\n\t\t\t\tsocial;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - barreiras: qualquer entrave, obstáculo, atitude ou\n\t\t\t\tcomportamento que limite ou impeça a participação social da pessoa, bem\n\t\t\t\tcomo o gozo, a fruição e o exercício de seus direitos à acessibilidade,\n\t\t\t\tà liberdade de movimento e de expressão, à comunicação, ao acesso à\n\t\t\t\tinformação, à compreensão, à circulação com segurança, entre outros,\n\t\t\t\tclassificadas em: a) barreiras urbanísticas: as existentes nas vias e\n\t\t\t\tnos espaços públicos e privados abertos ao público ou de uso coletivo;\n\t\t\t\tb) barreiras arquitetônicas: as existentes nos edifícios públicos e\n\t\t\t\tprivados; c) barreiras nos transportes: as existentes nos sistemas e\n\t\t\t\tmeios de transportes; d) barreiras nas comunicações e na informação:\n\t\t\t\tqualquer entrave, obstáculo, atitude ou comportamento que dificulte ou\n\t\t\t\timpossibilite a expressão ou o recebimento de mensagens e de informações\n\t\t\t\tpor intermédio de sistemas de comunicação e de tecnologia da informação;\n\t\t\t\te) barreiras atitudinais: atitudes ou comportamentos que impeçam ou\n\t\t\t\tprejudiquem a participação social da pessoa com deficiência em igualdade\n\t\t\t\tde condições e oportunidades com as demais pessoas; f) barreiras\n\t\t\t\ttecnológicas: as que dificultam ou impedem o acesso da pessoa com\n\t\t\t\tdeficiência às tecnologias;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - comunicação: forma de interação dos\n\t\t\t\tcidadãos que abrange, entre outras opções, as línguas, inclusive a\n\t\t\t\tLíngua Brasileira de Sinais (Libras), a visualização de textos, o\n\t\t\t\tBraille, o sistema de sinalização ou de comunicação tátil, os caracteres\n\t\t\t\tampliados, os dispositivos multimídia, assim como a linguagem simples,\n\t\t\t\tescrita e oral, os sistemas auditivos e os meios de voz digitalizados e\n\t\t\t\tos modos, meios e formatos aumentativos e alternativos de comunicação,\n\t\t\t\tincluindo as tecnologias da informação e das comunicações; VI -\n\t\t\t\tadaptações razoáveis: adaptações, modificações e ajustes necessários e\n\t\t\t\tadequados que não acarretem ônus desproporcional e indevido, quando\n\t\t\t\trequeridos em cada caso, a fim de assegurar que a pessoa com deficiência\n\t\t\t\tpossa gozar ou exercer, em igualdade de condições e oportunidades com as\n\t\t\t\tdemais pessoas, todos os direitos e liberdades fundamentais; VII -\n\t\t\t\telemento de urbanização: quaisquer componentes de obras de urbanização,\n\t\t\t\ttais como os referentes a pavimentação, saneamento, encanamento para\n\t\t\t\tesgotos, distribuição de energia elétrica e de gás, iluminação pública,\n\t\t\t\tserviços de comunicação, abastecimento e distribuição de água,\n\t\t\t\tpaisagismo e os que materializam as indicações do planejamento\n\t\t\t\turbanístico;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VIII - mobiliário urbano: conjunto de objetos existentes\n\t\t\t\tnas vias e nos espaços públicos, superpostos ou adicionados aos\n\t\t\t\telementos de urbanização ou de edificação, de forma que sua modificação\n\t\t\t\tou seu traslado não provoque alterações substanciais nesses elementos,\n\t\t\t\ttais como semáforos, postes de sinalização e similares, terminais e\n\t\t\t\tpontos de acesso coletivo às telecomunicações, fontes de água, lixeiras,\n\t\t\t\ttoldos, marquises, bancos, quiosques e quaisquer outros de natureza\n\t\t\t\tanáloga;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IX - pessoa com mobilidade reduzida: aquela que tenha, por\n\t\t\t\tqualquer motivo, dificuldade de movimentação, permanente ou temporária,\n\t\t\t\tgerando redução efetiva da mobilidade, da flexibilidade, da coordenação\n\t\t\t\tmotora ou da percepção, incluindo idoso, gestante, lactante, pessoa com\n\t\t\t\tcriança de colo e obeso;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " X - residências inclusivas: unidades de oferta\n\t\t\t\tdo Serviço de Acolhimento do Sistema Único de Assistência Social (Suas)\n\t\t\t\tlocalizadas em áreas residenciais da comunidade, com estruturas\n\t\t\t\tadequadas, que possam contar com apoio psicossocial para o atendimento\n\t\t\t\tdas necessidades da pessoa acolhida, destinadas a jovens e adultos com\n\t\t\t\tdeficiência, em situação de dependência, que não dispõem de condições de\n\t\t\t\tautossustentabilidade e com vínculos familiares fragilizados ou\n\t\t\t\trompidos;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XI - moradia para a vida independente da pessoa com\n\t\t\t\tdeficiência: moradia com estruturas adequadas capazes de proporcionar\n\t\t\t\tserviços de apoio coletivos e individualizados que respeitem e ampliem o\n\t\t\t\tgrau de autonomia de jovens e adultos com deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XII - atendente\n\t\t\t\tpessoal: pessoa, membro ou não da família, que, com ou sem remuneração,\n\t\t\t\tassiste ou presta cuidados básicos e essenciais à pessoa com deficiência\n\t\t\t\tno exercício de suas atividades diárias, excluídas as técnicas ou os\n\t\t\t\tprocedimentos identificados com profissões legalmente estabelecidas;\n\t\t\t\tXIII - profissional de apoio escolar: pessoa que exerce atividades de\n\t\t\t\talimentação, higiene e locomoção do estudante com deficiência e atua em\n\t\t\t\ttodas as atividades escolares nas quais se fizer necessária, em todos os\n\t\t\t\tníveis e modalidades de ensino, em instituições públicas e privadas,\n\t\t\t\texcluídas as técnicas ou os procedimentos identificados com profissões\n\t\t\t\tlegalmente estabelecidas;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XIV - acompanhante: aquele que acompanha a\n\t\t\t\tpessoa com deficiência, podendo ou não desempenhar as funções de\n\t\t\t\tatendente pessoal. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("CAPÍTULO II")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DA IGUALDADE E DA NÃO DISCRIMINAÇÃO")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t4º Toda pessoa com deficiência tem direito à igualdade de oportunidades\n\t\t\t\tcom as demais pessoas e não sofrerá nenhuma espécie de discriminação. §\n\t\t\t\t1º Considera-se discriminação em razão da deficiência toda forma de\n\t\t\t\tdistinção, restrição ou exclusão, por ação ou omissão, que tenha o\n\t\t\t\tpropósito ou o efeito de prejudicar, impedir ou anular o reconhecimento\n\t\t\t\tou o exercício dos direitos e das liberdades fundamentais de pessoa com\n\t\t\t\tdeficiência, incluindo a recusa de adaptações razoáveis e de\n\t\t\t\tfornecimento de tecnologias assistivas. § 2º A pessoa com deficiência\n\t\t\t\tnão está obrigada à fruição de benefícios decorrentes de ação\n\t\t\t\tafirmativa. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 5º A pessoa com deficiência será protegida de toda\n\t\t\t\tforma de negligência, discriminação, exploração, violência, tortura,\n\t\t\t\tcrueldade, opressão e tratamento desumano ou degradante. Parágrafo\n\t\t\t\túnico. Para os fins da proteção mencionada no caput deste artigo, são\n\t\t\t\tconsiderados especialmente vulneráveis a criança, o adolescente, a\n\t\t\t\tmulher e o idoso, com deficiência. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 6º A deficiência não afeta a\n\t\t\t\tplena capacidade civil da pessoa, inclusive para:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - casar-se e\n\t\t\t\tconstituir união estável;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - exercer direitos sexuais e reprodutivos;\n\t\t\t\tIII - exercer o direito de decidir sobre o número de filhos e de ter\n\t\t\t\tacesso a informações adequadas sobre reprodução e planejamento familiar;\n\t\t\t\tIV - conservar sua fertilidade, sendo vedada a esterilização\n\t\t\t\tcompulsória;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - exercer o direito à família e à convivência familiar e\n\t\t\t\tcomunitária; e"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VI - exercer o direito à guarda, à tutela, à curatela e à\n\t\t\t\tadoção, como adotante ou adotando, em igualdade de oportunidades com as\n\t\t\t\tdemais pessoas. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 7º É dever de todos comunicar à autoridade\n\t\t\t\tcompetente qualquer forma de ameaça ou de violação aos direitos da\n\t\t\t\tpessoa com deficiência. Parágrafo único. Se, no exercício de suas\n\t\t\t\tfunções, os juízes e os tribunais tiverem conhecimento de fatos que\n\t\t\t\tcaracterizem as violações previstas nesta Lei, devem remeter peças ao\n\t\t\t\tMinistério Público para as providências cabíveis. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 8º É dever do\n\t\t\t\tEstado, da sociedade e da família assegurar à pessoa com deficiência,\n\t\t\t\tcom prioridade, a efetivação dos direitos referentes à vida, à saúde, à\n\t\t\t\tsexualidade, à paternidade e à maternidade, à alimentação, à habitação,\n\t\t\t\tà educação, à profissionalização, ao trabalho, à previdência social, à\n\t\t\t\thabilitação e à reabilitação, ao transporte, à acessibilidade, à\n\t\t\t\tcultura, ao desporto, ao turismo, ao lazer, à informação, à comunicação,\n\t\t\t\taos avanços científicos e tecnológicos, à dignidade, ao respeito, à\n\t\t\t\tliberdade, à convivência familiar e comunitária, entre outros\n\t\t\t\tdecorrentes da Constituição Federal, da Convenção sobre os Direitos das\n\t\t\t\tPessoas com Deficiência e seu Protocolo Facultativo e das leis e de\n\t\t\t\toutras normas que garantam seu bem-estar pessoal, social e econômico.\n\t\t\t\tSeção Única Do Atendimento Prioritário "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 9º A pessoa com deficiência\n\t\t\t\ttem direito a receber atendimento prioritário, sobretudo com a\n\t\t\t\tfinalidade de:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - proteção e socorro em quaisquer circunstâncias; II -\n\t\t\t\tatendimento em todas as instituições e serviços de atendimento ao\n\t\t\t\tpúblico;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - disponibilização de recursos, tanto humanos quanto\n\t\t\t\ttecnológicos, que garantam atendimento em igualdade de condições com as\n\t\t\t\tdemais pessoas;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - disponibilização de pontos de parada, estações e\n\t\t\t\tterminais acessíveis de transporte coletivo de passageiros e garantia de\n\t\t\t\tsegurança no embarque e no desembarque;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - acesso a informações e\n\t\t\t\tdisponibilização de recursos de comunicação acessíveis;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VI - recebimento\n\t\t\t\tde restituição de imposto de renda;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VII - tramitação processual e\n\t\t\t\tprocedimentos judiciais e administrativos em que for parte ou\n\t\t\t\tinteressada, em todos os atos e diligências. § 1º Os direitos previstos\n\t\t\t\tneste artigo são extensivos ao acompanhante da pessoa com deficiência ou\n\t\t\t\tao seu atendente pessoal, exceto quanto ao disposto nos incisos VI e VII\n\t\t\t\tdeste artigo. § 2º Nos serviços de emergência públicos e privados, a\n\t\t\t\tprioridade conferida por esta Lei é condicionada aos protocolos de\n\t\t\t\tatendimento médico.     "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("TÍTULO II")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DOS DIREITOS FUNDAMENTAIS")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("CAPÍTULO I")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DO DIREITO À VIDA")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 10. Compete ao poder público garantir a dignidade da\n\t\t\t\tpessoa com deficiência ao longo de toda a vida. Parágrafo único. Em\n\t\t\t\tsituações de risco, emergência ou estado de calamidade pública, a pessoa\n\t\t\t\tcom deficiência será considerada vulnerável, devendo o poder público\n\t\t\t\tadotar medidas para sua proteção e segurança. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 11. A pessoa com\n\t\t\t\tdeficiência não poderá ser obrigada a se submeter a intervenção clínica\n\t\t\t\tou cirúrgica, a tratamento ou a institucionalização forçada. Parágrafo\n\t\t\t\túnico. O consentimento da pessoa com deficiência em situação de curatela\n\t\t\t\tpoderá ser suprido, na forma da lei. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 12. O consentimento prévio,\n\t\t\t\tlivre e esclarecido da pessoa com deficiência é indispensável para a\n\t\t\t\trealização de tratamento, procedimento, hospitalização e pesquisa\n\t\t\t\tcientífica. § 1º Em caso de pessoa com deficiência em situação de\n\t\t\t\tcuratela, deve ser assegurada sua participação, no maior grau possível,\n\t\t\t\tpara a obtenção de consentimento. § 2º A pesquisa científica envolvendo\n\t\t\t\tpessoa com deficiência em situação de tutela ou de curatela deve ser\n\t\t\t\trealizada, em caráter excepcional, apenas quando houver indícios de\n\t\t\t\tbenefício direto para sua saúde ou para a saúde de outras pessoas com\n\t\t\t\tdeficiência e desde que não haja outra opção de pesquisa de eficácia\n\t\t\t\tcomparável com participantes não tutelados ou curatelados. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 13. A\n\t\t\t\tpessoa com deficiência somente será atendida sem seu consentimento\n\t\t\t\tprévio, livre e esclarecido em casos de risco de morte e de emergência\n\t\t\t\tem saúde, resguardado seu superior interesse e adotadas as salvaguardas\n\t\t\t\tlegais cabíveis. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nCAPÍTULO II")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "DO DIREITO À HABILITAÇÃO E À REABILITAÇÃO\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 14. O processo de habilitação e de reabilitação é um direito da\n\t\t\t\tpessoa com deficiência. Parágrafo único. O processo de habilitação e de\n\t\t\t\treabilitação tem por objetivo o desenvolvimento de potencialidades,\n\t\t\t\ttalentos, habilidades e aptidões físicas, cognitivas, sensoriais,\n\t\t\t\tpsicossociais, atitudinais, profissionais e artísticas que contribuam\n\t\t\t\tpara a conquista da autonomia da pessoa com deficiência e de sua\n\t\t\t\tparticipação social em igualdade de condições e oportunidades com as\n\t\t\t\tdemais pessoas. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 15. O processo mencionado no ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 14 desta Lei\n\t\t\t\tbaseia-se em avaliação multidisciplinar das necessidades, habilidades e\n\t\t\t\tpotencialidades de cada pessoa, observadas as seguintes diretrizes: I -\n\t\t\t\tdiagnóstico e intervenção precoces;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - adoção de medidas para\n\t\t\t\tcompensar perda ou limitação funcional, buscando o desenvolvimento de\n\t\t\t\taptidões;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - atuação permanente, integrada e articulada de políticas\n\t\t\t\tpúblicas que possibilitem a plena participação social da pessoa com\n\t\t\t\tdeficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - oferta de rede de serviços articulados, com atuação\n\t\t\t\tintersetorial, nos diferentes níveis de complexidade, para atender às\n\t\t\t\tnecessidades específicas da pessoa com deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - prestação de\n\t\t\t\tserviços próximo ao domicílio da pessoa com deficiência, inclusive na\n\t\t\t\tzona rural, respeitadas a organização das Redes de Atenção à Saúde (RAS)\n\t\t\t\tnos territórios locais e as normas do Sistema Único de Saúde (SUS). "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t16. Nos programas e serviços de habilitação e de reabilitação para a\n\t\t\t\tpessoa com deficiência, são garantidos:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - organização, serviços,\n\t\t\t\tmétodos, técnicas e recursos para atender às características de cada\n\t\t\t\tpessoa com deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - acessibilidade em todos os ambientes e\n\t\t\t\tserviços;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - tecnologia assistiva, tecnologia de reabilitação,\n\t\t\t\tmateriais e equipamentos adequados e apoio técnico profissional, de\n\t\t\t\tacordo com as especificidades de cada pessoa com deficiência; IV -\n\t\t\t\tcapacitação continuada de todos os profissionais que participem dos\n\t\t\t\tprogramas e serviços. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 17. Os serviços do SUS e do Suas deverão\n\t\t\t\tpromover ações articuladas para garantir à pessoa com deficiência e sua\n\t\t\t\tfamília a aquisição de informações, orientações e formas de acesso às\n\t\t\t\tpolíticas públicas disponíveis, com a finalidade de propiciar sua plena\n\t\t\t\tparticipação social. Parágrafo único. Os serviços de que trata o caput\n\t\t\t\tdeste artigo podem fornecer informações e orientações nas áreas de\n\t\t\t\tsaúde, de educação, de cultura, de esporte, de lazer, de transporte, de\n\t\t\t\tprevidência social, de assistência social, de habitação, de trabalho, de\n\t\t\t\tempreendedorismo, de acesso ao crédito, de promoção, proteção e defesa\n\t\t\t\tde direitos e nas demais áreas que possibilitem à pessoa com deficiência\n\t\t\t\texercer sua cidadania. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nCAPÍTULO III")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DO DIREITO À SAÚDE ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 18. É\n\t\t\t\tassegurada atenção integral à saúde da pessoa com deficiência em todos\n\t\t\t\tos níveis de complexidade, por intermédio do SUS, garantido acesso\n\t\t\t\tuniversal e igualitário. § 1º É assegurada a participação da pessoa com\n\t\t\t\tdeficiência na elaboração das políticas de saúde a ela destinadas. § 2º\n\t\t\t\tÉ assegurado atendimento segundo normas éticas e técnicas, que\n\t\t\t\tregulamentarão a atuação dos profissionais de saúde e contemplarão\n\t\t\t\taspectos relacionados aos direitos e às especificidades da pessoa com\n\t\t\t\tdeficiência, incluindo temas como sua dignidade e autonomia. § 3º Aos\n\t\t\t\tprofissionais que prestam assistência à pessoa com deficiência,\n\t\t\t\tespecialmente em serviços de habilitação e de reabilitação, deve ser\n\t\t\t\tgarantida capacitação inicial e continuada. § 4º As ações e os serviços\n\t\t\t\tde saúde pública destinados à pessoa com deficiência devem assegurar: I\n\t\t\t\t- diagnóstico e intervenção precoces, realizados por equipe\n\t\t\t\tmultidisciplinar;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - serviços de habilitação e de reabilitação sempre\n\t\t\t\tque necessários, para qualquer tipo de deficiência, inclusive para a\n\t\t\t\tmanutenção da melhor condição de saúde e qualidade de vida; III -\n\t\t\t\tatendimento domiciliar multidisciplinar, tratamento ambulatorial e\n\t\t\t\tinternação;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" IV - campanhas de vacinação;")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - atendimento psicológico,\n\t\t\t\tinclusive para seus familiares e atendentes pessoais;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VI - respeito à\n\t\t\t\tespecificidade, à identidade de gênero e à orientação sexual da pessoa\n\t\t\t\tcom deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VII - atenção sexual e reprodutiva, incluindo o direito\n\t\t\t\tà fertilização assistida;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VIII - informação adequada e acessível à\n\t\t\t\tpessoa com deficiência e a seus familiares sobre sua condição de saúde;\n\t\t\t\tIX - serviços projetados para prevenir a ocorrência e o desenvolvimento\n\t\t\t\tde deficiências e agravos adicionais;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " X - promoção de estratégias de\n\t\t\t\tcapacitação permanente das equipes que atuam no SUS, em todos os níveis\n\t\t\t\tde atenção, no atendimento à pessoa com deficiência, bem como orientação\n\t\t\t\ta seus atendentes pessoais;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XI - oferta de órteses, próteses, meios\n\t\t\t\tauxiliares de locomoção, medicamentos, insumos e fórmulas nutricionais,\n\t\t\t\tconforme as normas vigentes do Ministério da Saúde. § 5º As diretrizes\n\t\t\t\tdeste artigo aplicam-se também às instituições privadas que participem\n\t\t\t\tde forma complementar do SUS ou que recebam recursos públicos para sua\n\t\t\t\tmanutenção. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 19. Compete ao SUS desenvolver ações destinadas à\n\t\t\t\tprevenção de deficiências por causas evitáveis, inclusive por meio de: I\n\t\t\t\t- acompanhamento da gravidez, do parto e do puerpério, com garantia de\n\t\t\t\tparto humanizado e seguro;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - promoção de práticas alimentares\n\t\t\t\tadequadas e saudáveis, vigilância alimentar e nutricional, prevenção e\n\t\t\t\tcuidado integral dos agravos relacionados à alimentação e nutrição da\n\t\t\t\tmulher e da criança;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - aprimoramento e expansão dos programas de\n\t\t\t\timunização e de triagem neonatal;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - identificação e controle da\n\t\t\t\tgestante de alto risco."
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - aprimoramento do atendimento neonatal, com a\n\t\t\t\toferta de ações e serviços de prevenção de danos cerebrais e sequelas\n\t\t\t\tneurológicas em recém-nascidos, inclusive por telessaúde. (Incluído pela\n\t\t\t\tLei nº 14.510, de 2022) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 20. As operadoras de planos e seguros\n\t\t\t\tprivados de saúde são obrigadas a garantir à pessoa com deficiência, no\n\t\t\t\tmínimo, todos os serviços e produtos ofertados aos demais clientes. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t21. Quando esgotados os meios de atenção à saúde da pessoa com\n\t\t\t\tdeficiência no local de residência, será prestado atendimento fora de\n\t\t\t\tdomicílio, para fins de diagnóstico e de tratamento, garantidos o\n\t\t\t\ttransporte e a acomodação da pessoa com deficiência e de seu\n\t\t\t\tacompanhante. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 22. À pessoa com deficiência internada ou em\n\t\t\t\tobservação é assegurado o direito a acompanhante ou a atendente pessoal,\n\t\t\t\tdevendo o órgão ou a instituição de saúde proporcionar condições\n\t\t\t\tadequadas para sua permanência em tempo integral. § 1º Na\n\t\t\t\timpossibilidade de permanência do acompanhante ou do atendente pessoal\n\t\t\t\tjunto à pessoa com deficiência, cabe ao profissional de saúde\n\t\t\t\tresponsável pelo tratamento justificá-la por escrito. § 2º Na ocorrência\n\t\t\t\tda impossibilidade prevista no § 1º deste artigo, o órgão ou a\n\t\t\t\tinstituição de saúde deve adotar as providências cabíveis para suprir a\n\t\t\t\tausência do acompanhante ou do atendente pessoal. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 23. São vedadas\n\t\t\t\ttodas as formas de discriminação contra a pessoa com deficiência,\n\t\t\t\tinclusive por meio de cobrança de valores diferenciados por planos e\n\t\t\t\tseguros privados de saúde, em razão de sua condição. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 24. É\n\t\t\t\tassegurado à pessoa com deficiência o acesso aos serviços de saúde,\n\t\t\t\ttanto públicos como privados, e às informações prestadas e recebidas,\n\t\t\t\tpor meio de recursos de tecnologia assistiva e de todas as formas de\n\t\t\t\tcomunicação previstas no inciso V do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("art. 3º desta Lei. ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 25. Os\n\t\t\t\tespaços dos serviços de saúde, tanto públicos quanto privados, devem\n\t\t\t\tassegurar o acesso da pessoa com deficiência, em conformidade com a\n\t\t\t\tlegislação em vigor, mediante a remoção de barreiras, por meio de\n\t\t\t\tprojetos arquitetônico, de ambientação de interior e de comunicação que\n\t\t\t\tatendam às especificidades das pessoas com deficiência física,\n\t\t\t\tsensorial, intelectual e mental. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 26. Os casos de suspeita ou de\n\t\t\t\tconfirmação de violência praticada contra a pessoa com deficiência serão\n\t\t\t\tobjeto de notificação compulsória pelos serviços de saúde públicos e\n\t\t\t\tprivados à autoridade policial e ao Ministério Público, além dos\n\t\t\t\tConselhos dos Direitos da Pessoa com Deficiência. Parágrafo único. Para\n\t\t\t\tos efeitos desta Lei, considera-se violência contra a pessoa com\n\t\t\t\tdeficiência qualquer ação ou omissão, praticada em local público ou\n\t\t\t\tprivado, que lhe cause morte ou dano ou sofrimento físico ou\n\t\t\t\tpsicológico. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nCAPÍTULO IV")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DO DIREITO À EDUCAÇÃO ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 27. A educação\n\t\t\t\tconstitui direito da pessoa com deficiência, assegurados sistema\n\t\t\t\teducacional inclusivo em todos os níveis e aprendizado ao longo de toda\n\t\t\t\ta vida, de forma a alcançar o máximo desenvolvimento possível de seus\n\t\t\t\ttalentos e habilidades físicas, sensoriais, intelectuais e sociais,\n\t\t\t\tsegundo suas características, interesses e necessidades de aprendizagem.\n\t\t\t\tParágrafo único. É dever do Estado, da família, da comunidade escolar e\n\t\t\t\tda sociedade assegurar educação de qualidade à pessoa com deficiência,\n\t\t\t\tcolocando-a a salvo de toda forma de violência, negligência e\n\t\t\t\tdiscriminação. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 28. Incumbe ao poder público assegurar, criar,\n\t\t\t\tdesenvolver, implementar, incentivar, acompanhar e avaliar:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - sistema\n\t\t\t\teducacional inclusivo em todos os níveis e modalidades, bem como o\n\t\t\t\taprendizado ao longo de toda a vida;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - aprimoramento dos sistemas\n\t\t\t\teducacionais, visando a garantir condições de acesso, permanência,\n\t\t\t\tparticipação e aprendizagem, por meio da oferta de serviços e de\n\t\t\t\trecursos de acessibilidade que eliminem as barreiras e promovam a\n\t\t\t\tinclusão plena;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - projeto pedagógico que institucionalize o\n\t\t\t\tatendimento educacional especializado, assim como os demais serviços e\n\t\t\t\tadaptações razoáveis, para atender às características dos estudantes com\n\t\t\t\tdeficiência e garantir o seu pleno acesso ao currículo em condições de\n\t\t\t\tigualdade, promovendo a conquista e o exercício de sua autonomia; IV -\n\t\t\t\toferta de educação bilíngue, em Libras como primeira língua e na\n\t\t\t\tmodalidade escrita da língua portuguesa como segunda língua, em escolas\n\t\t\t\te classes bilíngues e em escolas inclusivas;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - adoção de medidas\n\t\t\t\tindividualizadas e coletivas em ambientes que maximizem o\n\t\t\t\tdesenvolvimento acadêmico e social dos estudantes com deficiência,\n\t\t\t\tfavorecendo o acesso, a permanência, a participação e a aprendizagem em\n\t\t\t\tinstituições de ensino;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VI - pesquisas voltadas para o desenvolvimento\n\t\t\t\tde novos métodos e técnicas pedagógicas, de materiais didáticos, de\n\t\t\t\tequipamentos e de recursos de tecnologia assistiva;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VII - planejamento\n\t\t\t\tde estudo de caso, de elaboração de plano de atendimento educacional\n\t\t\t\tespecializado, de organização de recursos e serviços de acessibilidade e\n\t\t\t\tde disponibilização e usabilidade pedagógica de recursos de tecnologia\n\t\t\t\tassistiva;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VIII - participação dos estudantes com deficiência e de suas\n\t\t\t\tfamílias nas diversas instâncias de atuação da comunidade escolar; IX -\n\t\t\t\tadoção de medidas de apoio que favoreçam o desenvolvimento dos aspectos\n\t\t\t\tlinguísticos, culturais, vocacionais e profissionais, levando-se em\n\t\t\t\tconta o talento, a criatividade, as habilidades e os interesses do\n\t\t\t\testudante com deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " X - adoção de práticas pedagógicas inclusivas\n\t\t\t\tpelos programas de formação inicial e continuada de professores e oferta\n\t\t\t\tde formação continuada para o atendimento educacional especializado; XI\n\t\t\t\t- formação e disponibilização de professores para o atendimento\n\t\t\t\teducacional especializado, de tradutores e intérpretes da Libras, de\n\t\t\t\tguias intérpretes e de profissionais de apoio;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XII - oferta de ensino da\n\t\t\t\tLibras, do Sistema Braille e de uso de recursos de tecnologia assistiva,\n\t\t\t\tde forma a ampliar habilidades funcionais dos estudantes, promovendo sua\n\t\t\t\tautonomia e participação;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XIII - acesso à educação superior e à educação\n\t\t\t\tprofissional e tecnológica em igualdade de oportunidades e condições com\n\t\t\t\tas demais pessoas;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XIV - inclusão em conteúdos curriculares, em cursos\n\t\t\t\tde nível superior e de educação profissional técnica e tecnológica, de\n\t\t\t\ttemas relacionados à pessoa com deficiência nos respectivos campos de\n\t\t\t\tconhecimento;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XV - acesso da pessoa com deficiência, em igualdade de\n\t\t\t\tcondições, a jogos e a atividades recreativas, esportivas e de lazer, no\n\t\t\t\tsistema escolar;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XVI - acessibilidade para todos os estudantes,\n\t\t\t\ttrabalhadores da educação e demais integrantes da comunidade escolar às\n\t\t\t\tedificações, aos ambientes e às atividades concernentes a todas as\n\t\t\t\tmodalidades, etapas e níveis de ensino;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XVII - oferta de profissionais\n\t\t\t\tde apoio escolar;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " XVIII - articulação intersetorial na implementação de\n\t\t\t\tpolíticas públicas. § 1º Às instituições privadas, de qualquer nível e\n\t\t\t\tmodalidade de ensino, aplica-se obrigatoriamente o disposto nos incisos\n\t\t\t\tI, II, III, V, VII, VIII, IX, X, XI, XII, XIII, XIV, XV, XVI, XVII e\n\t\t\t\tXVIII do caput deste artigo, sendo vedada a cobrança de valores\n\t\t\t\tadicionais de qualquer natureza em suas mensalidades, anuidades e\n\t\t\t\tmatrículas no cumprimento dessas determinações. § 2º Na disponibilização\n\t\t\t\tde tradutores e intérpretes da Libras a que se refere o inciso XI do\n\t\t\t\tcaput deste artigo, deve-se observar o seguinte:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - os tradutores e\n\t\t\t\tintérpretes da Libras atuantes na educação básica devem, no mínimo,\n\t\t\t\tpossuir ensino médio completo e certificado de proficiência na Libras;\n\t\t\t\t(Vigência)"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - os tradutores e intérpretes da Libras, quando\n\t\t\t\tdirecionados à tarefa de interpretar nas salas de aula dos cursos de\n\t\t\t\tgraduação e pós-graduação, devem possuir nível superior, com\n\t\t\t\thabilitação, prioritariamente, em Tradução e Interpretação em Libras.\n\t\t\t\t(Vigência) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 29. (VETADO). ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 30. Nos processos seletivos para\n\t\t\t\tingresso e permanência nos cursos oferecidos pelas instituições de\n\t\t\t\tensino superior e de educação profissional e tecnológica, públicas e\n\t\t\t\tprivadas, devem ser adotadas as seguintes medidas:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - atendimento\n\t\t\t\tpreferencial à pessoa com deficiência nas dependências das Instituições\n\t\t\t\tde Ensino Superior (IES) e nos serviços;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - disponibilização de\n\t\t\t\tformulário de inscrição de exames com campos específicos para que o\n\t\t\t\tcandidato com deficiência informe os recursos de acessibilidade e de\n\t\t\t\ttecnologia assistiva necessários para sua participação; III -\n\t\t\t\tdisponibilização de provas em formatos acessíveis para atendimento às\n\t\t\t\tnecessidades específicas do candidato com deficiência; IV -\n\t\t\t\tdisponibilização de recursos de acessibilidade e de tecnologia assistiva\n\t\t\t\tadequados, previamente solicitados e escolhidos pelo candidato com\n\t\t\t\tdeficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - dilação de tempo, conforme demanda apresentada pelo\n\t\t\t\tcandidato com deficiência, tanto na realização de exame para seleção\n\t\t\t\tquanto nas atividades acadêmicas, mediante prévia solicitação e\n\t\t\t\tcomprovação da necessidade;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VI - adoção de critérios de avaliação das\n\t\t\t\tprovas escritas, discursivas ou de redação que considerem a\n\t\t\t\tsingularidade linguística da pessoa com deficiência, no domínio da\n\t\t\t\tmodalidade escrita da língua portuguesa;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VII - tradução completa do\n\t\t\t\tedital e de suas retificações em Libras. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nCAPÍTULO V")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DO DIREITO À MORADIA\n\t\t\t\t")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 31. A pessoa com deficiência tem direito à moradia digna, no seio\n\t\t\t\tda família natural ou substituta, com seu cônjuge ou companheiro ou\n\t\t\t\tdesacompanhada, ou em moradia para a vida independente da pessoa com\n\t\t\t\tdeficiência, ou, ainda, em residência inclusiva. § 1º O poder público\n\t\t\t\tadotará programas e ações estratégicas para apoiar a criação e a\n\t\t\t\tmanutenção de moradia para a vida independente da pessoa com\n\t\t\t\tdeficiência. § 2º A proteção integral na modalidade de residência\n\t\t\t\tinclusiva será prestada no âmbito do Suas à pessoa com deficiência em\n\t\t\t\tsituação de dependência que não disponha de condições de\n\t\t\t\tautossustentabilidade, com vínculos familiares fragilizados ou rompidos.\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 32. Nos programas habitacionais, públicos ou subsidiados com\n\t\t\t\trecursos públicos, a pessoa com deficiência ou o seu responsável goza de\n\t\t\t\tprioridade na aquisição de imóvel para moradia própria, observado o\n\t\t\t\tseguinte:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - reserva de, no mínimo, 3% (três por cento) das unidades\n\t\t\t\thabitacionais para pessoa com deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" II - (VETADO);")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - em caso\n\t\t\t\tde edificação multifamiliar, garantia de acessibilidade nas áreas de uso\n\t\t\t\tcomum e nas unidades habitacionais no piso térreo e de acessibilidade ou\n\t\t\t\tde adaptação razoável nos demais pisos;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - disponibilização de\n\t\t\t\tequipamentos urbanos comunitários acessíveis;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - elaboração de\n\t\t\t\tespecificações técnicas no projeto que permitam a instalação de\n\t\t\t\televadores. § 1º O direito à prioridade, previsto no caput deste artigo,\n\t\t\t\tserá reconhecido à pessoa com deficiência beneficiária apenas uma vez. §\n\t\t\t\t2º Nos programas habitacionais públicos, os critérios de financiamento\n\t\t\t\tdevem ser compatíveis com os rendimentos da pessoa com deficiência ou de\n\t\t\t\tsua família. § 3º Caso não haja pessoa com deficiência interessada nas\n\t\t\t\tunidades habitacionais reservadas por força do disposto no inciso I do\n\t\t\t\tcaput deste artigo, as unidades não utilizadas serão disponibilizadas às\n\t\t\t\tdemais pessoas. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 33. Ao poder público compete:")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - adotar as\n\t\t\t\tprovidências necessárias para o cumprimento do disposto nos arts. 31 e\n\t\t\t\t32 desta Lei; e"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - divulgar, para os agentes interessados e\n\t\t\t\tbeneficiários, a política habitacional prevista nas legislações federal,\n\t\t\t\testaduais, distrital e municipais, com ênfase nos dispositivos sobre\n\t\t\t\tacessibilidade. CAPÍTULO VI DO DIREITO AO TRABALHO Seção I Disposições\n\t\t\t\tGerais "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 34. A pessoa com deficiência tem direito ao trabalho de sua\n\t\t\t\tlivre escolha e aceitação, em ambiente acessível e inclusivo, em\n\t\t\t\tigualdade de oportunidades com as demais pessoas. § 1º As pessoas\n\t\t\t\tjurídicas de direito público, privado ou de qualquer natureza são\n\t\t\t\tobrigadas a garantir ambientes de trabalho acessíveis e inclusivos. § 2º\n\t\t\t\tA pessoa com deficiência tem direito, em igualdade de oportunidades com\n\t\t\t\tas demais pessoas, a condições justas e favoráveis de trabalho,\n\t\t\t\tincluindo igual remuneração por trabalho de igual valor. § 3º É vedada\n\t\t\t\trestrição ao trabalho da pessoa com deficiência e qualquer discriminação\n\t\t\t\tem razão de sua condição, inclusive nas etapas de recrutamento, seleção,\n\t\t\t\tcontratação, admissão, exames admissional e periódico, permanência no\n\t\t\t\temprego, ascensão profissional e reabilitação profissional, bem como\n\t\t\t\texigência de aptidão plena. § 4º A pessoa com deficiência tem direito à\n\t\t\t\tparticipação e ao acesso a cursos, treinamentos, educação continuada,\n\t\t\t\tplanos de carreira, promoções, bonificações e incentivos profissionais\n\t\t\t\toferecidos pelo empregador, em igualdade de oportunidades com os demais\n\t\t\t\tempregados. § 5º É garantida aos trabalhadores com deficiência\n\t\t\t\tacessibilidade em cursos de formação e de capacitação. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 35. É\n\t\t\t\tfinalidade primordial das políticas públicas de trabalho e emprego\n\t\t\t\tpromover e garantir condições de acesso e de permanência da pessoa com\n\t\t\t\tdeficiência no campo de trabalho. Parágrafo único. Os programas de\n\t\t\t\testímulo ao empreendedorismo e ao trabalho autônomo, incluídos o\n\t\t\t\tcooperativismo e o associativismo, devem prever a participação da pessoa\n\t\t\t\tcom deficiência e a disponibilização de linhas de crédito, quando\n\t\t\t\tnecessárias. Seção II Da Habilitação Profissional e Reabilitação\n\t\t\t\tProfissional "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 36. O poder público deve implementar serviços e\n\t\t\t\tprogramas completos de habilitação profissional e de reabilitação\n\t\t\t\tprofissional para que a pessoa com deficiência possa ingressar,\n\t\t\t\tcontinuar ou retornar ao campo do trabalho, respeitados sua livre\n\t\t\t\tescolha, sua vocação e seu interesse. § 1º Equipe multidisciplinar\n\t\t\t\tindicará, com base em critérios previstos no § 1º do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 2º desta Lei,\n\t\t\t\tprograma de habilitação ou de reabilitação que possibilite à pessoa com\n\t\t\t\tdeficiência restaurar sua capacidade e habilidade profissional ou\n\t\t\t\tadquirir novas capacidades e habilidades de trabalho. § 2º A habilitação\n\t\t\t\tprofissional corresponde ao processo destinado a propiciar à pessoa com\n\t\t\t\tdeficiência aquisição de conhecimentos, habilidades e aptidões para\n\t\t\t\texercício de profissão ou de ocupação, permitindo nível suficiente de\n\t\t\t\tdesenvolvimento profissional para ingresso no campo de trabalho. § 3º Os\n\t\t\t\tserviços de habilitação profissional, de reabilitação profissional e de\n\t\t\t\teducação profissional devem ser dotados de recursos necessários para\n\t\t\t\tatender a toda pessoa com deficiência, independentemente de sua\n\t\t\t\tcaracterística específica, a fim de que ela possa ser capacitada para\n\t\t\t\ttrabalho que lhe seja adequado e ter perspectivas de obtê-lo, de\n\t\t\t\tconservá-lo e de nele progredir. § 4º Os serviços de habilitação\n\t\t\t\tprofissional, de reabilitação profissional e de educação profissional\n\t\t\t\tdeverão ser oferecidos em ambientes acessíveis e inclusivos. § 5º A\n\t\t\t\thabilitação profissional e a reabilitação profissional devem ocorrer\n\t\t\t\tarticuladas com as redes públicas e privadas, especialmente de saúde, de\n\t\t\t\tensino e de assistência social, em todos os níveis e modalidades, em\n\t\t\t\tentidades de formação profissional ou diretamente com o empregador. § 6º\n\t\t\t\tA habilitação profissional pode ocorrer em empresas por meio de prévia\n\t\t\t\tformalização do contrato de emprego da pessoa com deficiência, que será\n\t\t\t\tconsiderada para o cumprimento da reserva de vagas prevista em lei,\n\t\t\t\tdesde que por tempo determinado e concomitante com a inclusão\n\t\t\t\tprofissional na empresa, observado o disposto em regulamento. § 7º A\n\t\t\t\thabilitação profissional e a reabilitação profissional atenderão à\n\t\t\t\tpessoa com deficiência. Seção III Da Inclusão da Pessoa com Deficiência\n\t\t\t\tno Trabalho "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 37. Constitui modo de inclusão da pessoa com\n\t\t\t\tdeficiência no trabalho a colocação competitiva, em igualdade de\n\t\t\t\toportunidades com as demais pessoas, nos termos da legislação\n\t\t\t\ttrabalhista e previdenciária, na qual devem ser atendidas as regras de\n\t\t\t\tacessibilidade, o fornecimento de recursos de tecnologia assistiva e a\n\t\t\t\tadaptação razoável no ambiente de trabalho. Parágrafo único. A colocação\n\t\t\t\tcompetitiva da pessoa com deficiência pode ocorrer por meio de trabalho\n\t\t\t\tcom apoio, observadas as seguintes diretrizes:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - prioridade no\n\t\t\t\tatendimento à pessoa com deficiência com maior dificuldade de inserção\n\t\t\t\tno campo de trabalho;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - provisão de suportes individualizados que\n\t\t\t\tatendam a necessidades específicas da pessoa com deficiência, inclusive\n\t\t\t\ta disponibilização de recursos de tecnologia assistiva, de agente\n\t\t\t\tfacilitador e de apoio no ambiente de trabalho;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - respeito ao perfil\n\t\t\t\tvocacional e ao interesse da pessoa com deficiência apoiada;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - oferta\n\t\t\t\tde aconselhamento e de apoio aos empregadores, com vistas à definição de\n\t\t\t\testratégias de inclusão e de superação de barreiras, inclusive\n\t\t\t\tatitudinais;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" V - realização de avaliações periódicas;")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VI - articulação\n\t\t\t\tintersetorial das políticas públicas;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VII - possibilidade de\n\t\t\t\tparticipação de organizações da sociedade civil. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 38. A entidade\n\t\t\t\tcontratada para a realização de processo seletivo público ou privado\n\t\t\t\tpara cargo, função ou emprego está obrigada à observância do disposto\n\t\t\t\tnesta Lei e em outras normas de acessibilidade vigentes. CAPÍTULO VII DO\n\t\t\t\tDIREITO À ASSISTÊNCIA SOCIAL "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 39. Os serviços, os programas, os\n\t\t\t\tprojetos e os benefícios no âmbito da política pública de assistência\n\t\t\t\tsocial à pessoa com deficiência e sua família têm como objetivo a\n\t\t\t\tgarantia da segurança de renda, da acolhida, da habilitação e da\n\t\t\t\treabilitação, do desenvolvimento da autonomia e da convivência familiar\n\t\t\t\te comunitária, para a promoção do acesso a direitos e da plena\n\t\t\t\tparticipação social. § 1º A assistência social à pessoa com deficiência,\n\t\t\t\tnos termos do caput deste artigo, deve envolver conjunto articulado de\n\t\t\t\tserviços do âmbito da Proteção Social Básica e da Proteção Social\n\t\t\t\tEspecial, ofertados pelo Suas, para a garantia de seguranças\n\t\t\t\tfundamentais no enfrentamento de situações de vulnerabilidade e de\n\t\t\t\trisco, por fragilização de vínculos e ameaça ou violação de direitos. §\n\t\t\t\t2º Os serviços socioassistenciais destinados à pessoa com deficiência em\n\t\t\t\tsituação de dependência deverão contar com cuidadores sociais para\n\t\t\t\tprestar-lhe cuidados básicos e instrumentais. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 40. É assegurado à\n\t\t\t\tpessoa com deficiência que não possua meios para prover sua subsistência\n\t\t\t\tnem de tê-la provida por sua família o benefício mensal de 1 (um)\n\t\t\t\tsalário-mínimo, nos termos da Lei nº 8.742, de 7 de dezembro de 1993 .\n\t\t\t\tCAPÍTULO VIII DO DIREITO À PREVIDÊNCIA SOCIAL "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 41. A pessoa com\n\t\t\t\tdeficiência segurada do Regime Geral de Previdência Social (RGPS) tem\n\t\t\t\tdireito à aposentadoria nos termos da Lei Complementar nº 142, de 8 de\n\t\t\t\tmaio de 2013 . CAPÍTULO IX DO DIREITO À CULTURA, AO ESPORTE, AO TURISMO\n\t\t\t\tE AO LAZER "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 42. A pessoa com deficiência tem direito à cultura, ao\n\t\t\t\tesporte, ao turismo e ao lazer em igualdade de oportunidades com as\n\t\t\t\tdemais pessoas, sendo-lhe garantido o acesso:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - a bens culturais em\n\t\t\t\tformato acessível;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - a programas de televisão, cinema, teatro e\n\t\t\t\toutras atividades culturais e desportivas em formato acessível; e III -\n\t\t\t\ta monumentos e locais de importância cultural e a espaços que ofereçam\n\t\t\t\tserviços ou eventos culturais e esportivos. § 1º É vedada a recusa de\n\t\t\t\toferta de obra intelectual em formato acessível à pessoa com\n\t\t\t\tdeficiência, sob qualquer argumento, inclusive sob a alegação de\n\t\t\t\tproteção dos direitos de propriedade intelectual. § 2º O poder público\n\t\t\t\tdeve adotar soluções destinadas à eliminação, à redução ou à superação\n\t\t\t\tde barreiras para a promoção do acesso a todo patrimônio cultural,\n\t\t\t\tobservadas as normas de acessibilidade, ambientais e de proteção do\n\t\t\t\tpatrimônio histórico e artístico nacional. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 43. O poder público deve\n\t\t\t\tpromover a participação da pessoa com deficiência em atividades\n\t\t\t\tartísticas, intelectuais, culturais, esportivas e recreativas, com\n\t\t\t\tvistas ao seu protagonismo, devendo:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - incentivar a provisão de\n\t\t\t\tinstrução, de treinamento e de recursos adequados, em igualdade de\n\t\t\t\toportunidades com as demais pessoas;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - assegurar acessibilidade nos\n\t\t\t\tlocais de eventos e nos serviços prestados por pessoa ou entidade\n\t\t\t\tenvolvida na organização das atividades de que trata este artigo; e III\n\t\t\t\t- assegurar a participação da pessoa com deficiência em jogos e\n\t\t\t\tatividades recreativas, esportivas, de lazer, culturais e artísticas,\n\t\t\t\tinclusive no sistema escolar, em igualdade de condições com as demais\n\t\t\t\tpessoas. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 44. Nos teatros, cinemas, auditórios, estádios, ginásios\n\t\t\t\tde esporte, locais de espetáculos e de conferências e similares, serão\n\t\t\t\treservados espaços livres e assentos para a pessoa com deficiência, de\n\t\t\t\tacordo com a capacidade de lotação da edificação, observado o disposto\n\t\t\t\tem regulamento. § 1º Os espaços e assentos a que se refere este artigo\n\t\t\t\tdevem ser distribuídos pelo recinto em locais diversos, de boa\n\t\t\t\tvisibilidade, em todos os setores, próximos aos corredores, devidamente\n\t\t\t\tsinalizados, evitando-se áreas segregadas de público e obstrução das\n\t\t\t\tsaídas, em conformidade com as normas de acessibilidade. § 2º No caso de\n\t\t\t\tnão haver comprovada procura pelos assentos reservados, esses podem,\n\t\t\t\texcepcionalmente, ser ocupados por pessoas sem deficiência ou que não\n\t\t\t\ttenham mobilidade reduzida, observado o disposto em regulamento. § 3º Os\n\t\t\t\tespaços e assentos a que se refere este artigo devem situar-se em locais\n\t\t\t\tque garantam a acomodação de, no mínimo, 1 (um) acompanhante da pessoa\n\t\t\t\tcom deficiência ou com mobilidade reduzida, resguardado o direito de se\n\t\t\t\tacomodar proximamente a grupo familiar e comunitário. § 4º Nos locais\n\t\t\t\treferidos no caput deste artigo, deve haver, obrigatoriamente, rotas de\n\t\t\t\tfuga e saídas de emergência acessíveis, conforme padrões das normas de\n\t\t\t\tacessibilidade, a fim de permitir a saída segura da pessoa com\n\t\t\t\tdeficiência ou com mobilidade reduzida, em caso de emergência. § 5º\n\t\t\t\tTodos os espaços das edificações previstas no caput deste artigo devem\n\t\t\t\tatender às normas de acessibilidade em vigor. § 6º As salas de cinema\n\t\t\t\tdevem oferecer, em todas as sessões, recursos de acessibilidade para a\n\t\t\t\tpessoa com deficiência. (Vigência) § 7º O valor do ingresso da pessoa\n\t\t\t\tcom deficiência não poderá ser superior ao valor cobrado das demais\n\t\t\t\tpessoas. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 45. Os hotéis, pousadas e similares devem ser construídos\n\t\t\t\tobservando-se os princípios do desenho universal, além de adotar todos\n\t\t\t\tos meios de acessibilidade, conforme legislação em vigor. (Vigência)\n\t\t\t\t(Reglamento) § 1º Os estabelecimentos já existentes deverão\n\t\t\t\tdisponibilizar, pelo menos, 10% (dez por cento) de seus dormitórios\n\t\t\t\tacessíveis, garantida, no mínimo, 1 (uma) unidade acessível. § 2º Os\n\t\t\t\tdormitórios mencionados no § 1º deste artigo deverão ser localizados em\n\t\t\t\trotas acessíveis. CAPÍTULO X DO DIREITO AO TRANSPORTE E À MOBILIDADE\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 46. O direito ao transporte e à mobilidade da pessoa com\n\t\t\t\tdeficiência ou com mobilidade reduzida será assegurado em igualdade de\n\t\t\t\toportunidades com as demais pessoas, por meio de identificação e de\n\t\t\t\teliminação de todos os obstáculos e barreiras ao seu acesso. § 1º Para\n\t\t\t\tfins de acessibilidade aos serviços de transporte coletivo terrestre,\n\t\t\t\taquaviário e aéreo, em todas as jurisdições, consideram-se como\n\t\t\t\tintegrantes desses serviços os veículos, os terminais, as estações, os\n\t\t\t\tpontos de parada, o sistema viário e a prestação do serviço. § 2º São\n\t\t\t\tsujeitas ao cumprimento das disposições desta Lei, sempre que houver\n\t\t\t\tinteração com a matéria nela regulada, a outorga, a concessão, a\n\t\t\t\tpermissão, a autorização, a renovação ou a habilitação de linhas e de\n\t\t\t\tserviços de transporte coletivo. § 3º Para colocação do símbolo\n\t\t\t\tinternacional de acesso nos veículos, as empresas de transporte coletivo\n\t\t\t\tde passageiros dependem da certificação de acessibilidade emitida pelo\n\t\t\t\tgestor público responsável pela prestação do serviço. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 47. Em todas\n\t\t\t\tas áreas de estacionamento aberto ao público, de uso público ou privado\n\t\t\t\tde uso coletivo e em vias públicas, devem ser reservadas vagas próximas\n\t\t\t\taos acessos de circulação de pedestres, devidamente sinalizadas, para\n\t\t\t\tveículos que transportem pessoa com deficiência com comprometimento de\n\t\t\t\tmobilidade, desde que devidamente identificados. § 1º As vagas a que se\n\t\t\t\trefere o caput deste artigo devem equivaler a 2% (dois por cento) do\n\t\t\t\ttotal, garantida, no mínimo, 1 (uma) vaga devidamente sinalizada e com\n\t\t\t\tas especificações de desenho e traçado de acordo com as normas técnicas\n\t\t\t\tvigentes de acessibilidade. § 2º Os veículos estacionados nas vagas\n\t\t\t\treservadas devem exibir, em local de ampla visibilidade, a credencial de\n\t\t\t\tbeneficiário, a ser confeccionada e fornecida pelos órgãos de trânsito,\n\t\t\t\tque disciplinarão suas características e condições de uso. § 3º A\n\t\t\t\tutilização indevida das vagas de que trata este artigo sujeita os\n\t\t\t\tinfratores às sanções previstas no inciso XVII do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 181 da Lei nº\n\t\t\t\t9.503, de 23 de setembro de 1997 (Código de Trânsito Brasileiro) . § 3º\n\t\t\t\tA utilização indevida das vagas de que trata este artigo sujeita os\n\t\t\t\tinfratores às sanções previstas no inciso XX do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 181 da Lei nº\n\t\t\t\t9.503, de 23 de setembro de 1997 (Código de Trânsito Brasileiro) .\n\t\t\t\t(Redação dada pela Lei nº 13.281, de 2016) (Vigência) § 4º A credencial\n\t\t\t\ta que se refere o § 2º deste artigo é vinculada à pessoa com deficiência\n\t\t\t\tque possui comprometimento de mobilidade e é válida em todo o território\n\t\t\t\tnacional. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 48. Os veículos de transporte coletivo terrestre,\n\t\t\t\taquaviário e aéreo, as instalações, as estações, os portos e os\n\t\t\t\tterminais em operação no País devem ser acessíveis, de forma a garantir\n\t\t\t\to seu uso por todas as pessoas. § 1º Os veículos e as estruturas de que\n\t\t\t\ttrata o caput deste artigo devem dispor de sistema de comunicação\n\t\t\t\tacessível que disponibilize informações sobre todos os pontos do\n\t\t\t\titinerário. § 2º São asseguradas à pessoa com deficiência prioridade e\n\t\t\t\tsegurança nos procedimentos de embarque e de desembarque nos veículos de\n\t\t\t\ttransporte coletivo, de acordo com as normas técnicas. § 3º Para\n\t\t\t\tcolocação do símbolo internacional de acesso nos veículos, as empresas\n\t\t\t\tde transporte coletivo de passageiros dependem da certificação de\n\t\t\t\tacessibilidade emitida pelo gestor público responsável pela prestação do\n\t\t\t\tserviço. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 49. As empresas de transporte de fretamento e de turismo,\n\t\t\t\tna renovação de suas frotas, são obrigadas ao cumprimento do disposto\n\t\t\t\tnos arts. 46 e 48 desta Lei. (Vigência) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 50. O poder público\n\t\t\t\tincentivará a fabricação de veículos acessíveis e a sua utilização como\n\t\t\t\ttáxis e vans , de forma a garantir o seu uso por todas as pessoas. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t51. As frotas de empresas de táxi devem reservar 10% (dez por cento) de\n\t\t\t\tseus veículos acessíveis à pessoa com deficiência. (Vide Decreto nº\n\t\t\t\t9.762, de 2019) (Vigência) § 1º É proibida a cobrança diferenciada de\n\t\t\t\ttarifas ou de valores adicionais pelo serviço de táxi prestado à pessoa\n\t\t\t\tcom deficiência. § 2º O poder público é autorizado a instituir\n\t\t\t\tincentivos fiscais com vistas a possibilitar a acessibilidade dos\n\t\t\t\tveículos a que se refere o caput deste artigo. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 52. As locadoras de\n\t\t\t\tveículos são obrigadas a oferecer 1 (um) veículo adaptado para uso de\n\t\t\t\tpessoa com deficiência, a cada conjunto de 20 (vinte) veículos de sua\n\t\t\t\tfrota. (Vide Decreto nº 9.762, de 2019) (Vigência) Parágrafo único. O\n\t\t\t\tveículo adaptado deverá ter, no mínimo, câmbio automático, direção\n\t\t\t\thidráulica, vidros elétricos e comandos manuais de freio e de embreagem.\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nTítulo III ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DA ACESSIBILIDADE CAPÍTULO I DISPOSIÇÕES GERAIS ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 53. A\n\t\t\t\tacessibilidade é direito que garante à pessoa com deficiência ou com\n\t\t\t\tmobilidade reduzida viver de forma independente e exercer seus direitos\n\t\t\t\tde cidadania e de participação social. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 54. São sujeitas ao\n\t\t\t\tcumprimento das disposições desta Lei e de outras normas relativas à\n\t\t\t\tacessibilidade, sempre que houver interação com a matéria nela regulada:\n\t\t\t\tI - a aprovação de projeto arquitetônico e urbanístico ou de comunicação\n\t\t\t\te informação, a fabricação de veículos de transporte coletivo, a\n\t\t\t\tprestação do respectivo serviço e a execução de qualquer tipo de obra,\n\t\t\t\tquando tenham destinação pública ou coletiva;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - a outorga ou a\n\t\t\t\trenovação de concessão, permissão, autorização ou habilitação de\n\t\t\t\tqualquer natureza;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - a aprovação de financiamento de projeto com\n\t\t\t\tutilização de recursos públicos, por meio de renúncia ou de incentivo\n\t\t\t\tfiscal, contrato, convênio ou instrumento congênere; e"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - a concessão\n\t\t\t\tde aval da União para obtenção de empréstimo e de financiamento\n\t\t\t\tinternacionais por entes públicos ou privados. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 55. A concepção e a\n\t\t\t\timplantação de projetos que tratem do meio físico, de transporte, de\n\t\t\t\tinformação e comunicação, inclusive de sistemas e tecnologias da\n\t\t\t\tinformação e comunicação, e de outros serviços, equipamentos e\n\t\t\t\tinstalações abertos ao público, de uso público ou privado de uso\n\t\t\t\tcoletivo, tanto na zona urbana como na rural, devem atender aos\n\t\t\t\tprincípios do desenho universal, tendo como referência as normas de\n\t\t\t\tacessibilidade. § 1º O desenho universal será sempre tomado como regra\n\t\t\t\tde caráter geral. § 2º Nas hipóteses em que comprovadamente o desenho\n\t\t\t\tuniversal não possa ser empreendido, deve ser adotada adaptação\n\t\t\t\trazoável. § 3º Caberá ao poder público promover a inclusão de conteúdos\n\t\t\t\ttemáticos referentes ao desenho universal nas diretrizes curriculares da\n\t\t\t\teducação profissional e tecnológica e do ensino superior e na formação\n\t\t\t\tdas carreiras de Estado. § 4º Os programas, os projetos e as linhas de\n\t\t\t\tpesquisa a serem desenvolvidos com o apoio de organismos públicos de\n\t\t\t\tauxílio à pesquisa e de agências de fomento deverão incluir temas\n\t\t\t\tvoltados para o desenho universal. § 5º Desde a etapa de concepção, as\n\t\t\t\tpolíticas públicas deverão considerar a adoção do desenho universal.\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 56. A construção, a reforma, a ampliação ou a mudança de uso de\n\t\t\t\tedificações abertas ao público, de uso público ou privadas de uso\n\t\t\t\tcoletivo deverão ser executadas de modo a serem acessíveis. § 1º As\n\t\t\t\tentidades de fiscalização profissional das atividades de Engenharia, de\n\t\t\t\tArquitetura e correlatas, ao anotarem a responsabilidade técnica de\n\t\t\t\tprojetos, devem exigir a responsabilidade profissional declarada de\n\t\t\t\tatendimento às regras de acessibilidade previstas em legislação e em\n\t\t\t\tnormas técnicas pertinentes. § 2º Para a aprovação, o licenciamento ou a\n\t\t\t\temissão de certificado de projeto executivo arquitetônico, urbanístico e\n\t\t\t\tde instalações e equipamentos temporários ou permanentes e para o\n\t\t\t\tlicenciamento ou a emissão de certificado de conclusão de obra ou de\n\t\t\t\tserviço, deve ser atestado o atendimento às regras de acessibilidade. §\n\t\t\t\t3º O poder público, após certificar a acessibilidade de edificação ou de\n\t\t\t\tserviço, determinará a colocação, em espaços ou em locais de ampla\n\t\t\t\tvisibilidade, do símbolo internacional de acesso, na forma prevista em\n\t\t\t\tlegislação e em normas técnicas correlatas. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 57. As edificações\n\t\t\t\tpúblicas e privadas de uso coletivo já existentes devem garantir\n\t\t\t\tacessibilidade à pessoa com deficiência em todas as suas dependências e\n\t\t\t\tserviços, tendo como referência as normas de acessibilidade vigentes.\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 58. O projeto e a construção de edificação de uso privado\n\t\t\t\tmultifamiliar devem atender aos preceitos de acessibilidade, na forma\n\t\t\t\tregulamentar. (Regulamento) § 1º As construtoras e incorporadoras\n\t\t\t\tresponsáveis pelo projeto e pela construção das edificações a que se\n\t\t\t\trefere o caput deste artigo devem assegurar percentual mínimo de suas\n\t\t\t\tunidades internamente acessíveis, na forma regulamentar. § 2º É vedada a\n\t\t\t\tcobrança de valores adicionais para a aquisição de unidades internamente\n\t\t\t\tacessíveis a que se refere o § 1º deste artigo. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 59. Em qualquer\n\t\t\t\tintervenção nas vias e nos espaços públicos, o poder público e as\n\t\t\t\tempresas concessionárias responsáveis pela execução das obras e dos\n\t\t\t\tserviços devem garantir, de forma segura, a fluidez do trânsito e a\n\t\t\t\tlivre circulação e acessibilidade das pessoas, durante e após sua\n\t\t\t\texecução. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 60. Orientam-se, no que couber, pelas regras de\n\t\t\t\tacessibilidade previstas em legislação e em normas técnicas, observado o\n\t\t\t\tdisposto na Lei nº 10.098, de 19 de dezembro de 2000 , nº 10.257, de 10\n\t\t\t\tde julho de 2001 , e nº 12.587, de 3 de janeiro de 2012 :"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - os planos\n\t\t\t\tdiretores municipais, os planos diretores de transporte e trânsito, os\n\t\t\t\tplanos de mobilidade urbana e os planos de preservação de sítios\n\t\t\t\thistóricos elaborados ou atualizados a partir da publicação desta Lei;\n\t\t\t\tII - os códigos de obras, os códigos de postura, as leis de uso e\n\t\t\t\tocupação do solo e as leis do sistema viário;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - os estudos prévios\n\t\t\t\tde impacto de vizinhança;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - as atividades de fiscalização e a\n\t\t\t\timposição de sanções; e"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - a legislação referente à prevenção contra\n\t\t\t\tincêndio e pânico. § 1º A concessão e a renovação de alvará de\n\t\t\t\tfuncionamento para qualquer atividade são condicionadas à observação e à\n\t\t\t\tcertificação das regras de acessibilidade. § 2º A emissão de carta de\n\t\t\t\thabite-se ou de habilitação equivalente e sua renovação, quando esta\n\t\t\t\ttiver sido emitida anteriormente às exigências de acessibilidade, é\n\t\t\t\tcondicionada à observação e à certificação das regras de acessibilidade.\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 61. A formulação, a implementação e a manutenção das ações de\n\t\t\t\tacessibilidade atenderão às seguintes premissas básicas:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - eleição de\n\t\t\t\tprioridades, elaboração de cronograma e reserva de recursos para\n\t\t\t\timplementação das ações; e"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - planejamento contínuo e articulado entre\n\t\t\t\tos setores envolvidos. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 62. É assegurado à pessoa com deficiência,\n\t\t\t\tmediante solicitação, o recebimento de contas, boletos, recibos,\n\t\t\t\textratos e cobranças de tributos em formato acessível. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nCAPÍTULO II")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DO\n\t\t\t\tACESSO À INFORMAÇÃO E À COMUNICAÇÃO ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 63. É obrigatória a\n\t\t\t\tacessibilidade nos sítios da internet mantidos por empresas com sede ou\n\t\t\t\trepresentação comercial no País ou por órgãos de governo, para uso da\n\t\t\t\tpessoa com deficiência, garantindo-lhe acesso às informações\n\t\t\t\tdisponíveis, conforme as melhores práticas e diretrizes de\n\t\t\t\tacessibilidade adotadas internacionalmente. § 1º Os sítios devem conter\n\t\t\t\tsímbolo de acessibilidade em destaque. § 2º Telecentros comunitários que\n\t\t\t\treceberem recursos públicos federais para seu custeio ou sua instalação\n\t\t\t\te lan houses devem possuir equipamentos e instalações acessíveis. § 3º\n\t\t\t\tOs telecentros e as lan houses de que trata o § 2º deste artigo devem\n\t\t\t\tgarantir, no mínimo, 10% (dez por cento) de seus computadores com\n\t\t\t\trecursos de acessibilidade para pessoa com deficiência visual, sendo\n\t\t\t\tassegurado pelo menos 1 (um) equipamento, quando o resultado percentual\n\t\t\t\tfor inferior a 1 (um). "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 64. A acessibilidade nos sítios da internet\n\t\t\t\tde que trata o "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 63 desta Lei deve ser observada para obtenção do\n\t\t\t\tfinanciamento de que trata o inciso III do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("art. 54 desta Lei. ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 65.\n\t\t\t\tAs empresas prestadoras de serviços de telecomunicações deverão garantir\n\t\t\t\tpleno acesso à pessoa com deficiência, conforme regulamentação\n\t\t\t\tespecífica. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 66. Cabe ao poder público incentivar a oferta de\n\t\t\t\taparelhos de telefonia fixa e móvel celular com acessibilidade que,\n\t\t\t\tentre outras tecnologias assistivas, possuam possibilidade de indicação\n\t\t\t\te de ampliação sonoras de todas as operações e funções disponíveis. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t67. Os serviços de radiodifusão de sons e imagens devem permitir o uso\n\t\t\t\tdos seguintes recursos, entre outros:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - subtitulação por meio de\n\t\t\t\tlegenda oculta;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - janela com intérprete da Libras; III -\n\t\t\t\taudiodescrição. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 68. O poder público deve adotar mecanismos de\n\t\t\t\tincentivo à produção, à edição, à difusão, à distribuição e à\n\t\t\t\tcomercialização de livros em formatos acessíveis, inclusive em\n\t\t\t\tpublicações da administração pública ou financiadas com recursos\n\t\t\t\tpúblicos, com vistas a garantir à pessoa com deficiência o direito de\n\t\t\t\tacesso à leitura, à informação e à comunicação. § 1º Nos editais de\n\t\t\t\tcompras de livros, inclusive para o abastecimento ou a atualização de\n\t\t\t\tacervos de bibliotecas em todos os níveis e modalidades de educação e de\n\t\t\t\tbibliotecas públicas, o poder público deverá adotar cláusulas de\n\t\t\t\timpedimento à participação de editoras que não ofertem sua produção\n\t\t\t\ttambém em formatos acessíveis. § 2º Consideram-se formatos acessíveis os\n\t\t\t\tarquivos digitais que possam ser reconhecidos e acessados por softwares\n\t\t\t\tleitores de telas ou outras tecnologias assistivas que vierem a\n\t\t\t\tsubstituí-los, permitindo leitura com voz sintetizada, ampliação de\n\t\t\t\tcaracteres, diferentes contrastes e impressão em Braille. § 3º O poder\n\t\t\t\tpúblico deve estimular e apoiar a adaptação e a produção de artigos\n\t\t\t\tcientíficos em formato acessível, inclusive em Libras. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 69. O poder\n\t\t\t\tpúblico deve assegurar a disponibilidade de informações corretas e\n\t\t\t\tclaras sobre os diferentes produtos e serviços ofertados, por quaisquer\n\t\t\t\tmeios de comunicação empregados, inclusive em ambiente virtual, contendo\n\t\t\t\ta especificação correta de quantidade, qualidade, características,\n\t\t\t\tcomposição e preço, bem como sobre os eventuais riscos à saúde e à\n\t\t\t\tsegurança do consumidor com deficiência, em caso de sua utilização,\n\t\t\t\taplicando-se, no que couber, os arts. 30 a 41 da Lei nº 8.078, de 11 de\n\t\t\t\tsetembro de 1990 . § 1º Os canais de comercialização virtual e os\n\t\t\t\tanúncios publicitários veiculados na imprensa escrita, na internet, no\n\t\t\t\trádio, na televisão e nos demais veículos de comunicação abertos ou por\n\t\t\t\tassinatura devem disponibilizar, conforme a compatibilidade do meio, os\n\t\t\t\trecursos de acessibilidade de que trata o "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 67 desta Lei, a expensas\n\t\t\t\tdo fornecedor do produto ou do serviço, sem prejuízo da observância do\n\t\t\t\tdisposto nos arts. 36 a 38 da Lei nº 8.078, de 11 de setembro de 1990 .\n\t\t\t\t§ 2º Os fornecedores devem disponibilizar, mediante solicitação,\n\t\t\t\texemplares de bulas, prospectos, textos ou qualquer outro tipo de\n\t\t\t\tmaterial de divulgação em formato acessível. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 70. As instituições\n\t\t\t\tpromotoras de congressos, seminários, oficinas e demais eventos de\n\t\t\t\tnatureza científico-cultural devem oferecer à pessoa com deficiência, no\n\t\t\t\tmínimo, os recursos de tecnologia assistiva previstos no "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("art. 67 desta\n\t\t\t\tLei. ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 71. Os congressos, os seminários, as oficinas e os demais\n\t\t\t\teventos de natureza científico-cultural promovidos ou financiados pelo\n\t\t\t\tpoder público devem garantir as condições de acessibilidade e os\n\t\t\t\trecursos de tecnologia assistiva. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 72. Os programas, as linhas de\n\t\t\t\tpesquisa e os projetos a serem desenvolvidos com o apoio de agências de\n\t\t\t\tfinanciamento e de órgãos e entidades integrantes da administração\n\t\t\t\tpública que atuem no auxílio à pesquisa devem contemplar temas voltados\n\t\t\t\tà tecnologia assistiva. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 73. Caberá ao poder público, diretamente ou\n\t\t\t\tem parceria com organizações da sociedade civil, promover a capacitação\n\t\t\t\tde tradutores e intérpretes da Libras, de guias intérpretes e de\n\t\t\t\tprofissionais habilitados em Braille, audiodescrição, estenotipia e\n\t\t\t\tlegendagem. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nCAPÍTULO III")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DA TECNOLOGIA ASSISTIVA ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 74. É garantido à\n\t\t\t\tpessoa com deficiência acesso a produtos, recursos, estratégias,\n\t\t\t\tpráticas, processos, métodos e serviços de tecnologia assistiva que\n\t\t\t\tmaximizem sua autonomia, mobilidade pessoal e qualidade de vida. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t75. O poder público desenvolverá plano específico de medidas, a ser\n\t\t\t\trenovado em cada período de 4 (quatro) anos, com a finalidade de:\n\t\t\t\t(Regulamento)"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - facilitar o acesso a crédito especializado, inclusive\n\t\t\t\tcom oferta de linhas de crédito subsidiadas, específicas para aquisição\n\t\t\t\tde tecnologia assistiva;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - agilizar, simplificar e priorizar\n\t\t\t\tprocedimentos de importação de tecnologia assistiva, especialmente as\n\t\t\t\tquestões atinentes a procedimentos alfandegários e sanitários; III -\n\t\t\t\tcriar mecanismos de fomento à pesquisa e à produção nacional de\n\t\t\t\ttecnologia assistiva, inclusive por meio de concessão de linhas de\n\t\t\t\tcrédito subsidiado e de parcerias com institutos de pesquisa oficiais;\n\t\t\t\tIV - eliminar ou reduzir a tributação da cadeia produtiva e de\n\t\t\t\timportação de tecnologia assistiva;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - facilitar e agilizar o processo\n\t\t\t\tde inclusão de novos recursos de tecnologia assistiva no rol de produtos\n\t\t\t\tdistribuídos no âmbito do SUS e por outros órgãos governamentais.\n\t\t\t\tParágrafo único. Para fazer cumprir o disposto neste artigo, os\n\t\t\t\tprocedimentos constantes do plano específico de medidas deverão ser\n\t\t\t\tavaliados, pelo menos, a cada 2 (dois) anos. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nCAPÍTULO IV")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "DO DIREITO À\n\t\t\t\tPARTICIPAÇÃO NA VIDA PÚBLICA E POLÍTICA "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 76. O poder público deve\n\t\t\t\tgarantir à pessoa com deficiência todos os direitos políticos e a\n\t\t\t\toportunidade de exercê-los em igualdade de condições com as demais\n\t\t\t\tpessoas. § 1º À pessoa com deficiência será assegurado o direito de\n\t\t\t\tvotar e de ser votada, inclusive por meio das seguintes ações: I -\n\t\t\t\tgarantia de que os procedimentos, as instalações, os materiais e os\n\t\t\t\tequipamentos para votação sejam apropriados, acessíveis a todas as\n\t\t\t\tpessoas e de fácil compreensão e uso, sendo vedada a instalação de\n\t\t\t\tseções eleitorais exclusivas para a pessoa com deficiência; II -\n\t\t\t\tincentivo à pessoa com deficiência a candidatar-se e a desempenhar\n\t\t\t\tquaisquer funções públicas em todos os níveis de governo, inclusive por\n\t\t\t\tmeio do uso de novas tecnologias assistivas, quando apropriado; III -\n\t\t\t\tgarantia de que os pronunciamentos oficiais, a propaganda eleitoral\n\t\t\t\tobrigatória e os debates transmitidos pelas emissoras de televisão\n\t\t\t\tpossuam, pelo menos, os recursos elencados no "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 67 desta Lei; IV -\n\t\t\t\tgarantia do livre exercício do direito ao voto e, para tanto, sempre que\n\t\t\t\tnecessário e a seu pedido, permissão para que a pessoa com deficiência\n\t\t\t\tseja auxiliada na votação por pessoa de sua escolha. § 2º O poder\n\t\t\t\tpúblico promoverá a participação da pessoa com deficiência, inclusive\n\t\t\t\tquando institucionalizada, na condução das questões públicas, sem\n\t\t\t\tdiscriminação e em igualdade de oportunidades, observado o seguinte: I -\n\t\t\t\tparticipação em organizações não governamentais relacionadas à vida\n\t\t\t\tpública e à política do País e em atividades e administração de partidos\n\t\t\t\tpolíticos;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - formação de organizações para representar a pessoa com\n\t\t\t\tdeficiência em todos os níveis;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - participação da pessoa com\n\t\t\t\tdeficiência em organizações que a representem. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nTítulo IV ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DA CIÊNCIA E\n\t\t\t\tTECNOLOGIA ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 77. O poder público deve fomentar o desenvolvimento\n\t\t\t\tcientífico, a pesquisa e a inovação e a capacitação tecnológicas,\n\t\t\t\tvoltados à melhoria da qualidade de vida e ao trabalho da pessoa com\n\t\t\t\tdeficiência e sua inclusão social. § 1º O fomento pelo poder público\n\t\t\t\tdeve priorizar a geração de conhecimentos e técnicas que visem à\n\t\t\t\tprevenção e ao tratamento de deficiências e ao desenvolvimento de\n\t\t\t\ttecnologias assistiva e social. § 2º A acessibilidade e as tecnologias\n\t\t\t\tassistiva e social devem ser fomentadas mediante a criação de cursos de\n\t\t\t\tpós-graduação, a formação de recursos humanos e a inclusão do tema nas\n\t\t\t\tdiretrizes de áreas do conhecimento. § 3º Deve ser fomentada a\n\t\t\t\tcapacitação tecnológica de instituições públicas e privadas para o\n\t\t\t\tdesenvolvimento de tecnologias assistiva e social que sejam voltadas\n\t\t\t\tpara melhoria da funcionalidade e da participação social da pessoa com\n\t\t\t\tdeficiência. § 4º As medidas previstas neste artigo devem ser\n\t\t\t\treavaliadas periodicamente pelo poder público, com vistas ao seu\n\t\t\t\taperfeiçoamento. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 78. Devem ser estimulados a pesquisa, o\n\t\t\t\tdesenvolvimento, a inovação e a difusão de tecnologias voltadas para\n\t\t\t\tampliar o acesso da pessoa com deficiência às tecnologias da informação\n\t\t\t\te comunicação e às tecnologias sociais. Parágrafo único. Serão\n\t\t\t\testimulados, em especial:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - o emprego de tecnologias da informação e\n\t\t\t\tcomunicação como instrumento de superação de limitações funcionais e de\n\t\t\t\tbarreiras à comunicação, à informação, à educação e ao entretenimento da\n\t\t\t\tpessoa com deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - a adoção de soluções e a difusão de normas\n\t\t\t\tque visem a ampliar a acessibilidade da pessoa com deficiência à\n\t\t\t\tcomputação e aos sítios da internet, em especial aos serviços de governo\n\t\t\t\teletrônico. LIVRO II PARTE ESPECIAL TÍTULO I DO ACESSO À JUSTIÇA\n\t\t\t\tCAPÍTULO I DISPOSIÇÕES GERAIS "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 79. O poder público deve assegurar o\n\t\t\t\tacesso da pessoa com deficiência à justiça, em igualdade de\n\t\t\t\toportunidades com as demais pessoas, garantindo, sempre que requeridos,\n\t\t\t\tadaptações e recursos de tecnologia assistiva. § 1º A fim de garantir a\n\t\t\t\tatuação da pessoa com deficiência em todo o processo judicial, o poder\n\t\t\t\tpúblico deve capacitar os membros e os servidores que atuam no Poder\n\t\t\t\tJudiciário, no Ministério Público, na Defensoria Pública, nos órgãos de\n\t\t\t\tsegurança pública e no sistema penitenciário quanto aos direitos da\n\t\t\t\tpessoa com deficiência. § 2º Devem ser assegurados à pessoa com\n\t\t\t\tdeficiência submetida a medida restritiva de liberdade todos os direitos\n\t\t\t\te garantias a que fazem jus os apenados sem deficiência, garantida a\n\t\t\t\tacessibilidade. § 3º A Defensoria Pública e o Ministério Público tomarão\n\t\t\t\tas medidas necessárias à garantia dos direitos previstos nesta Lei. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t80. Devem ser oferecidos todos os recursos de tecnologia assistiva\n\t\t\t\tdisponíveis para que a pessoa com deficiência tenha garantido o acesso à\n\t\t\t\tjustiça, sempre que figure em um dos polos da ação ou atue como\n\t\t\t\ttestemunha, partícipe da lide posta em juízo, advogado, defensor\n\t\t\t\tpúblico, magistrado ou membro do Ministério Público. Parágrafo único. A\n\t\t\t\tpessoa com deficiência tem garantido o acesso ao conteúdo de todos os\n\t\t\t\tatos processuais de seu interesse, inclusive no exercício da advocacia.\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 81. Os direitos da pessoa com deficiência serão garantidos por\n\t\t\t\tocasião da aplicação de sanções penais. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 82. (VETADO). ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 83. Os\n\t\t\t\tserviços notariais e de registro não podem negar ou criar óbices ou\n\t\t\t\tcondições diferenciadas à prestação de seus serviços em razão de\n\t\t\t\tdeficiência do solicitante, devendo reconhecer sua capacidade legal\n\t\t\t\tplena, garantida a acessibilidade. Parágrafo único. O descumprimento do\n\t\t\t\tdisposto no caput deste artigo constitui discriminação em razão de\n\t\t\t\tdeficiência. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nCAPÍTULO II")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DO RECONHECIMENTO IGUAL PERANTE A LEI ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 84.\n\t\t\t\tA pessoa com deficiência tem assegurado o direito ao exercício de sua\n\t\t\t\tcapacidade legal em igualdade de condições com as demais pessoas. § 1º\n\t\t\t\tQuando necessário, a pessoa com deficiência será submetida à curatela,\n\t\t\t\tconforme a lei. § 2º É facultado à pessoa com deficiência a adoção de\n\t\t\t\tprocesso de tomada de decisão apoiada. § 3º A definição de curatela de\n\t\t\t\tpessoa com deficiência constitui medida protetiva extraordinária,\n\t\t\t\tproporcional às necessidades e às circunstâncias de cada caso, e durará\n\t\t\t\to menor tempo possível. § 4º Os curadores são obrigados a prestar,\n\t\t\t\tanualmente, contas de sua administração ao juiz, apresentando o balanço\n\t\t\t\tdo respectivo ano. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 85. A curatela afetará tão somente os atos\n\t\t\t\trelacionados aos direitos de natureza patrimonial e negocial. § 1º A\n\t\t\t\tdefinição da curatela não alcança o direito ao próprio corpo, à\n\t\t\t\tsexualidade, ao matrimônio, à privacidade, à educação, à saúde, ao\n\t\t\t\ttrabalho e ao voto. § 2º A curatela constitui medida extraordinária,\n\t\t\t\tdevendo constar da sentença as razões e motivações de sua definição,\n\t\t\t\tpreservados os interesses do curatelado. § 3º No caso de pessoa em\n\t\t\t\tsituação de institucionalização, ao nomear curador, o juiz deve dar\n\t\t\t\tpreferência a pessoa que tenha vínculo de natureza familiar, afetiva ou\n\t\t\t\tcomunitária com o curatelado. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 86. Para emissão de documentos\n\t\t\t\toficiais, não será exigida a situação de curatela da pessoa com\n\t\t\t\tdeficiência. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 87. Em casos de relevância e urgência e a fim de\n\t\t\t\tproteger os interesses da pessoa com deficiência em situação de\n\t\t\t\tcuratela, será lícito ao juiz, ouvido o Ministério Público, de oficio ou\n\t\t\t\ta requerimento do interessado, nomear, desde logo, curador provisório, o\n\t\t\t\tqual estará sujeito, no que couber, às disposições do Código de Processo\n\t\t\t\tCivil . "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nTítulo II ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DOS CRIMES E DAS INFRAÇÕES ADMINISTRATIVAS ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 88.\n\t\t\t\tPraticar, induzir ou incitar discriminação de pessoa em razão de sua\n\t\t\t\tdeficiência: Pena - reclusão, de 1 (um) a 3 (três) anos, e multa. § 1º\n\t\t\t\tAumenta-se a pena em 1/3 (um terço) se a vítima encontrar-se sob cuidado\n\t\t\t\te responsabilidade do agente. § 2º Se qualquer dos crimes previstos no\n\t\t\t\tcaput deste artigo é cometido por intermédio de meios de comunicação\n\t\t\t\tsocial ou de publicação de qualquer natureza: Pena - reclusão, de 2\n\t\t\t\t(dois) a 5 (cinco) anos, e multa. § 3º Na hipótese do § 2º deste artigo,\n\t\t\t\to juiz poderá determinar, ouvido o Ministério Público ou a pedido deste,\n\t\t\t\tainda antes do inquérito policial, sob pena de desobediência: I -\n\t\t\t\trecolhimento ou busca e apreensão dos exemplares do material\n\t\t\t\tdiscriminatório;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - interdição das respectivas mensagens ou páginas de\n\t\t\t\tinformação na internet. § 4º Na hipótese do § 2º deste artigo, constitui\n\t\t\t\tefeito da condenação, após o trânsito em julgado da decisão, a\n\t\t\t\tdestruição do material apreendido. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 89. Apropriar-se de ou desviar\n\t\t\t\tbens, proventos, pensão, benefícios, remuneração ou qualquer outro\n\t\t\t\trendimento de pessoa com deficiência: Pena - reclusão, de 1 (um) a 4\n\t\t\t\t(quatro) anos, e multa. Parágrafo único. Aumenta-se a pena em 1/3 (um\n\t\t\t\tterço) se o crime é cometido:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - por tutor, curador, síndico,\n\t\t\t\tliquidatário, inventariante, testamenteiro ou depositário judicial; ou\n\t\t\t\tII - por aquele que se apropriou em razão de ofício ou de profissão.\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 90. Abandonar pessoa com deficiência em hospitais, casas de saúde,\n\t\t\t\tentidades de abrigamento ou congêneres: Pena - reclusão, de 6 (seis)\n\t\t\t\tmeses a 3 (três) anos, e multa. Parágrafo único. Na mesma pena incorre\n\t\t\t\tquem não prover as necessidades básicas de pessoa com deficiência quando\n\t\t\t\tobrigado por lei ou mandado. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 91. Reter ou utilizar cartão\n\t\t\t\tmagnético, qualquer meio eletrônico ou documento de pessoa com\n\t\t\t\tdeficiência destinados ao recebimento de benefícios, proventos, pensões\n\t\t\t\tou remuneração ou à realização de operações financeiras, com o fim de\n\t\t\t\tobter vantagem indevida para si ou para outrem: Pena - detenção, de 6\n\t\t\t\t(seis) meses a 2 (dois) anos, e multa. Parágrafo único. Aumenta-se a\n\t\t\t\tpena em 1/3 (um terço) se o crime é cometido por tutor ou curador.\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nTítulo III ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DISPOSIÇÕES FINAIS E TRANSITÓRIAS ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 92. É criado o\n\t\t\t\tCadastro Nacional de Inclusão da Pessoa com Deficiência\n\t\t\t\t(Cadastro-Inclusão), registro público eletrônico com a finalidade de\n\t\t\t\tcoletar, processar, sistematizar e disseminar informações\n\t\t\t\tgeorreferenciadas que permitam a identificação e a caracterização\n\t\t\t\tsocioeconômica da pessoa com deficiência, bem como das barreiras que\n\t\t\t\timpedem a realização de seus direitos. § 1º O Cadastro-Inclusão será\n\t\t\t\tadministrado pelo Poder Executivo federal e constituído por base de\n\t\t\t\tdados, instrumentos, procedimentos e sistemas eletrônicos. § 2º Os dados\n\t\t\t\tconstituintes do Cadastro-Inclusão serão obtidos pela integração dos\n\t\t\t\tsistemas de informação e da base de dados de todas as políticas públicas\n\t\t\t\trelacionadas aos direitos da pessoa com deficiência, bem como por\n\t\t\t\tinformações coletadas, inclusive em censos nacionais e nas demais\n\t\t\t\tpesquisas realizadas no País, de acordo com os parâmetros estabelecidos\n\t\t\t\tpela Convenção sobre os Direitos das Pessoas com Deficiência e seu\n\t\t\t\tProtocolo Facultativo. § 3º Para coleta, transmissão e sistematização de\n\t\t\t\tdados, é facultada a celebração de convênios, acordos, termos de\n\t\t\t\tparceria ou contratos com instituições públicas e privadas, observados\n\t\t\t\tos requisitos e procedimentos previstos em legislação específica. § 4º\n\t\t\t\tPara assegurar a confidencialidade, a privacidade e as liberdades\n\t\t\t\tfundamentais da pessoa com deficiência e os princípios éticos que regem\n\t\t\t\ta utilização de informações, devem ser observadas as salvaguardas\n\t\t\t\testabelecidas em lei. § 5º Os dados do Cadastro-Inclusão somente poderão\n\t\t\t\tser utilizados para as seguintes finalidades:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - formulação, gestão,\n\t\t\t\tmonitoramento e avaliação das políticas públicas para a pessoa com\n\t\t\t\tdeficiência e para identificar as barreiras que impedem a realização de\n\t\t\t\tseus direitos;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - realização de estudos e pesquisas. § 6º As\n\t\t\t\tinformações a que se refere este artigo devem ser disseminadas em\n\t\t\t\tformatos acessíveis. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 93. Na realização de inspeções e de auditorias\n\t\t\t\tpelos órgãos de controle interno e externo, deve ser observado o\n\t\t\t\tcumprimento da legislação relativa à pessoa com deficiência e das normas\n\t\t\t\tde acessibilidade vigentes. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 94. Terá direito a auxílio-inclusão,\n\t\t\t\tnos termos da lei, a pessoa com deficiência moderada ou grave que: I -\n\t\t\t\treceba o benefício de prestação continuada previsto no "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 20 da Lei nº\n\t\t\t\t8.742, de 7 de dezembro de 1993 , e que passe a exercer atividade\n\t\t\t\tremunerada que a enquadre como segurado obrigatório do RGPS;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - tenha\n\t\t\t\trecebido, nos últimos 5 (cinco) anos, o benefício de prestação\n\t\t\t\tcontinuada previsto no "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 20 da Lei nº 8.742, de 7 de dezembro de 1993\n\t\t\t\t, e que exerça atividade remunerada que a enquadre como segurado\n\t\t\t\tobrigatório do RGPS. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 95. É vedado exigir o comparecimento de pessoa\n\t\t\t\tcom deficiência perante os órgãos públicos quando seu deslocamento, em\n\t\t\t\trazão de sua limitação funcional e de condições de acessibilidade,\n\t\t\t\timponha-lhe ônus desproporcional e indevido, hipótese na qual serão\n\t\t\t\tobservados os seguintes procedimentos:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - quando for de interesse do\n\t\t\t\tpoder público, o agente promoverá o contato necessário com a pessoa com\n\t\t\t\tdeficiência em sua residência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - quando for de interesse da pessoa\n\t\t\t\tcom deficiência, ela apresentará solicitação de atendimento domiciliar\n\t\t\t\tou fará representar-se por procurador constituído para essa finalidade.\n\t\t\t\tParágrafo único. É assegurado à pessoa com deficiência atendimento\n\t\t\t\tdomiciliar pela perícia médica e social do Instituto Nacional do Seguro\n\t\t\t\tSocial (INSS), pelo serviço público de saúde ou pelo serviço privado de\n\t\t\t\tsaúde, contratado ou conveniado, que integre o SUS e pelas entidades da\n\t\t\t\trede socioassistencial integrantes do Suas, quando seu deslocamento, em\n\t\t\t\trazão de sua limitação funcional e de condições de acessibilidade,\n\t\t\t\timponha-lhe ônus desproporcional e indevido. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 96. O § 6º -A do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art.\n\t\t\t\t135 da Lei nº 4.737, de 15 de julho de 1965 (Código Eleitoral) , passa a\n\t\t\t\tvigorar com a seguinte redação: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 135.\n\t\t\t\t.................................................................\n\t\t\t\t........................................................................................\n\t\t\t\t§ 6º -A. Os Tribunais Regionais Eleitorais deverão, a cada eleição,\n\t\t\t\texpedir instruções aos Juízes Eleitorais para orientá-los na escolha dos\n\t\t\t\tlocais de votação, de maneira a garantir acessibilidade para o eleitor\n\t\t\t\tcom deficiência ou com mobilidade reduzida, inclusive em seu entorno e\n\t\t\t\tnos sistemas de transporte que lhe dão acesso.\n\t\t\t\t....................................................................................”\n\t\t\t\t(NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 97. A Consolidação das Leis do Trabalho (CLT), aprovada pelo\n\t\t\t\tDecreto-Lei nº 5.452, de 1º de maio de 1943 , passa a vigorar com as\n\t\t\t\tseguintes alterações: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 428.\n\t\t\t\t..................................................................\n\t\t\t\t...........................................................................................\n\t\t\t\t§ 6º Para os fins do contrato de aprendizagem, a comprovação da\n\t\t\t\tescolaridade de aprendiz com deficiência deve considerar, sobretudo, as\n\t\t\t\thabilidades e competências relacionadas com a profissionalização.\n\t\t\t\t...........................................................................................\n\t\t\t\t§ 8º Para o aprendiz com deficiência com 18 (dezoito) anos ou mais, a\n\t\t\t\tvalidade do contrato de aprendizagem pressupõe anotação na CTPS e\n\t\t\t\tmatrícula e frequência em programa de aprendizagem desenvolvido sob\n\t\t\t\torientação de entidade qualificada em formação técnico-profissional\n\t\t\t\tmetódica.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 433.\n\t\t\t\t..................................................................\n\t\t\t\t...........................................................................................\n\t\t\t\tI - desempenho insuficiente ou inadaptação do aprendiz, salvo para o\n\t\t\t\taprendiz com deficiência quando desprovido de recursos de\n\t\t\t\tacessibilidade, de tecnologias assistivas e de apoio necessário ao\n\t\t\t\tdesempenho de suas atividades;\n\t\t\t\t..................................................................................”\n\t\t\t\t(NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 98. A Lei nº 7.853, de 24 de outubro de 1989 , passa a vigorar\n\t\t\t\tcom as seguintes alterações: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 3º As medidas judiciais destinadas à\n\t\t\t\tproteção de interesses coletivos, difusos, individuais homogêneos e\n\t\t\t\tindividuais indisponíveis da pessoa com deficiência poderão ser\n\t\t\t\tpropostas pelo Ministério Público, pela Defensoria Pública, pela União,\n\t\t\t\tpelos Estados, pelos Municípios, pelo Distrito Federal, por associação\n\t\t\t\tconstituída há mais de 1 (um) ano, nos termos da lei civil, por\n\t\t\t\tautarquia, por empresa pública e por fundação ou sociedade de economia\n\t\t\t\tmista que inclua, entre suas finalidades institucionais, a proteção dos\n\t\t\t\tinteresses e a promoção de direitos da pessoa com deficiência.\n\t\t\t\t.................................................................................”\n\t\t\t\t(NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 8º Constitui crime punível com reclusão de 2 (dois) a 5\n\t\t\t\t(cinco) anos e multa:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - recusar, cobrar valores adicionais, suspender,\n\t\t\t\tprocrastinar, cancelar ou fazer cessar inscrição de aluno em\n\t\t\t\testabelecimento de ensino de qualquer curso ou grau, público ou privado,\n\t\t\t\tem razão de sua deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - obstar inscrição em concurso público\n\t\t\t\tou acesso de alguém a qualquer cargo ou emprego público, em razão de sua\n\t\t\t\tdeficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - negar ou obstar emprego, trabalho ou promoção à\n\t\t\t\tpessoa em razão de sua deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - recusar, retardar ou dificultar\n\t\t\t\tinternação ou deixar de prestar assistência médico-hospitalar e\n\t\t\t\tambulatorial à pessoa com deficiência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - deixar de cumprir, retardar\n\t\t\t\tou frustrar execução de ordem judicial expedida na ação civil a que\n\t\t\t\talude esta Lei;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VI - recusar, retardar ou omitir dados técnicos\n\t\t\t\tindispensáveis à propositura da ação civil pública objeto desta Lei,\n\t\t\t\tquando requisitados. § 1º Se o crime for praticado contra pessoa com\n\t\t\t\tdeficiência menor de 18 (dezoito) anos, a pena é agravada em 1/3 (um\n\t\t\t\tterço). § 2º A pena pela adoção deliberada de critérios subjetivos para\n\t\t\t\tindeferimento de inscrição, de aprovação e de cumprimento de estágio\n\t\t\t\tprobatório em concursos públicos não exclui a responsabilidade\n\t\t\t\tpatrimonial pessoal do administrador público pelos danos causados. § 3º\n\t\t\t\tIncorre nas mesmas penas quem impede ou dificulta o ingresso de pessoa\n\t\t\t\tcom deficiência em planos privados de assistência à saúde, inclusive com\n\t\t\t\tcobrança de valores diferenciados. § 4º Se o crime for praticado em\n\t\t\t\tatendimento de urgência e emergência, a pena é agravada em 1/3 (um\n\t\t\t\tterço).” (NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 99. O ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 20 da Lei nº 8.036, de 11 de maio de 1990\n\t\t\t\t, passa a vigorar acrescido do seguinte inciso XVIII: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 20.\n\t\t\t\t......................................................................\n\t\t\t\t..............................................................................................\n\t\t\t\tXVIII - quando o trabalhador com deficiência, por prescrição, necessite\n\t\t\t\tadquirir órtese ou prótese para promoção de acessibilidade e de inclusão\n\t\t\t\tsocial.\n\t\t\t\t..................................................................................”\n\t\t\t\t(NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 100. A Lei nº 8.078, de 11 de setembro de 1990 (Código de\n\t\t\t\tDefesa do Consumidor) , passa a vigorar com as seguintes alterações:\n\t\t\t\t“"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 6º\n\t\t\t\t.......................................................................\n\t\t\t\t............................................................................................\n\t\t\t\tParágrafo único. A informação de que trata o inciso III do caput deste\n\t\t\t\tartigo deve ser acessível à pessoa com deficiência, observado o disposto\n\t\t\t\tem regulamento.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 43.\n\t\t\t\t......................................................................\n\t\t\t\t............................................................................................\n\t\t\t\t§ 6º Todas as informações de que trata o caput deste artigo devem ser\n\t\t\t\tdisponibilizadas em formatos acessíveis, inclusive para a pessoa com\n\t\t\t\tdeficiência, mediante solicitação do consumidor.” (NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 101. A Lei\n\t\t\t\tnº 8.213, de 24 de julho de 1991 , passa a vigorar com as seguintes\n\t\t\t\talterações: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 16.\n\t\t\t\t...................................................................... I\n\t\t\t\t- o cônjuge, a companheira, o companheiro e o filho não emancipado, de\n\t\t\t\tqualquer condição, menor de 21 (vinte e um) anos ou inválido ou que\n\t\t\t\ttenha deficiência intelectual ou mental ou deficiência grave;\n\t\t\t\t............................................................................................\n\t\t\t\tIII - o irmão não emancipado, de qualquer condição, menor de 21 (vinte e\n\t\t\t\tum) anos ou inválido ou que tenha deficiência intelectual ou mental ou\n\t\t\t\tdeficiência grave;\n\t\t\t\t.................................................................................”\n\t\t\t\t(NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 77.\n\t\t\t\t.....................................................................\n\t\t\t\t............................................................................................\n\t\t\t\t§ 2º\n\t\t\t\t..............................................................................\n\t\t\t\t............................................................................................\n\t\t\t\tII - para o filho, a pessoa a ele equiparada ou o irmão, de ambos os\n\t\t\t\tsexos, pela emancipação ou ao completar 21 (vinte e um) anos de idade,\n\t\t\t\tsalvo se for inválido ou tiver deficiência intelectual ou mental ou\n\t\t\t\tdeficiência grave;\n\t\t\t\t...................................................................................\n\t\t\t\t§ 4º (VETADO).\n\t\t\t\t...................................................................................”\n\t\t\t\t(NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 93. (VETADO):")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" I - (VETADO);")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" II - (VETADO);")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" III - (VETADO); IV\n\t\t\t\t- (VETADO);")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - (VETADO). § 1º A dispensa de pessoa com deficiência ou\n\t\t\t\tde beneficiário reabilitado da Previdência Social ao final de contrato\n\t\t\t\tpor prazo determinado de mais de 90 (noventa) dias e a dispensa\n\t\t\t\timotivada em contrato por prazo indeterminado somente poderão ocorrer\n\t\t\t\tapós a contratação de outro trabalhador com deficiência ou beneficiário\n\t\t\t\treabilitado da Previdência Social. § 2º Ao Ministério do Trabalho e\n\t\t\t\tEmprego incumbe estabelecer a sistemática de fiscalização, bem como\n\t\t\t\tgerar dados e estatísticas sobre o total de empregados e as vagas\n\t\t\t\tpreenchidas por pessoas com deficiência e por beneficiários reabilitados\n\t\t\t\tda Previdência Social, fornecendo-os, quando solicitados, aos\n\t\t\t\tsindicatos, às entidades representativas dos empregados ou aos cidadãos\n\t\t\t\tinteressados. § 3º Para a reserva de cargos será considerada somente a\n\t\t\t\tcontratação direta de pessoa com deficiência, excluído o aprendiz com\n\t\t\t\tdeficiência de que trata a Consolidação das Leis do Trabalho (CLT),\n\t\t\t\taprovada pelo Decreto-Lei nº 5.452, de 1º de maio de 1943. § 4º\n\t\t\t\t(VETADO).” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 110-A. No ato de requerimento de benefícios\n\t\t\t\toperacionalizados pelo INSS, não será exigida apresentação de termo de\n\t\t\t\tcuratela de titular ou de beneficiário com deficiência, observados os\n\t\t\t\tprocedimentos a serem estabelecidos em regulamento.” "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 102. O ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 2º\n\t\t\t\tda Lei nº 8.313, de 23 de dezembro de 1991 , passa a vigorar acrescido\n\t\t\t\tdo seguinte § 3º : “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 2º\n\t\t\t\t.........................................................................\n\t\t\t\t.............................................................................................\n\t\t\t\t§ 3º Os incentivos criados por esta Lei somente serão concedidos a\n\t\t\t\tprojetos culturais que forem disponibilizados, sempre que tecnicamente\n\t\t\t\tpossível, também em formato acessível à pessoa com deficiência,\n\t\t\t\tobservado o disposto em regulamento.” (NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 103. O ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 11 da Lei nº\n\t\t\t\t8.429, de 2 de junho de 1992 , passa a vigorar acrescido do seguinte\n\t\t\t\tinciso IX: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 11.\n\t\t\t\t.....................................................................\n\t\t\t\t............................................................................................\n\t\t\t\tIX - deixar de cumprir a exigência de requisitos de acessibilidade\n\t\t\t\tprevistos na legislação.” (NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 104. A Lei nº 8.666, de 21 de junho\n\t\t\t\tde 1993 , passa a vigorar com as seguintes alterações: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 3º\n\t\t\t\t.....................................................................\n\t\t\t\t..........................................................................................\n\t\t\t\t§ 2º\n\t\t\t\t...........................................................................\n\t\t\t\t..........................................................................................\n\t\t\t\tV - produzidos ou prestados por empresas que comprovem cumprimento de\n\t\t\t\treserva de cargos prevista em lei para pessoa com deficiência ou para\n\t\t\t\treabilitado da Previdência Social e que atendam às regras de\n\t\t\t\tacessibilidade previstas na legislação.\n\t\t\t\t...........................................................................................\n\t\t\t\t§ 5º Nos processos de licitação, poderá ser estabelecida margem de\n\t\t\t\tpreferência para:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - produtos manufaturados e para serviços nacionais\n\t\t\t\tque atendam a normas técnicas brasileiras; e"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - bens e serviços\n\t\t\t\tproduzidos ou prestados por empresas que comprovem cumprimento de\n\t\t\t\treserva de cargos prevista em lei para pessoa com deficiência ou para\n\t\t\t\treabilitado da Previdência Social e que atendam às regras de\n\t\t\t\tacessibilidade previstas na legislação.\n\t\t\t\t...................................................................................”\n\t\t\t\t(NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 66-A. As empresas enquadradas no inciso V do § 2º e no inciso\n\t\t\t\tII do § 5º do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 3º desta Lei deverão cumprir, durante todo o período\n\t\t\t\tde execução do contrato, a reserva de cargos prevista em lei para pessoa\n\t\t\t\tcom deficiência ou para reabilitado da Previdência Social, bem como as\n\t\t\t\tregras de acessibilidade previstas na legislação. Parágrafo único. Cabe\n\t\t\t\tà administração fiscalizar o cumprimento dos requisitos de\n\t\t\t\tacessibilidade nos serviços e nos ambientes de trabalho.” "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 105. O\n\t\t\t\t")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 20 da Lei nº 8.742, de 7 de dezembro de 1993 , passa a vigorar com\n\t\t\t\tas seguintes alterações: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 20.\n\t\t\t\t......................................................................\n\t\t\t\t.............................................................................................\n\t\t\t\t§ 2º Para efeito de concessão do benefício de prestação continuada,\n\t\t\t\tconsidera-se pessoa com deficiência aquela que tem impedimento de longo\n\t\t\t\tprazo de natureza física, mental, intelectual ou sensorial, o qual, em\n\t\t\t\tinteração com uma ou mais barreiras, pode obstruir sua participação\n\t\t\t\tplena e efetiva na sociedade em igualdade de condições com as demais\n\t\t\t\tpessoas.\n\t\t\t\t............................................................................................\n\t\t\t\t§ 9º Os rendimentos decorrentes de estágio supervisionado e de\n\t\t\t\taprendizagem não serão computados para os fins de cálculo da renda\n\t\t\t\tfamiliar per capita a que se refere o § 3º deste artigo.\n\t\t\t\t.............................................................................................\n\t\t\t\t§ 11. Para concessão do benefício de que trata o caput deste artigo,\n\t\t\t\tpoderão ser utilizados outros elementos probatórios da condição de\n\t\t\t\tmiserabilidade do grupo familiar e da situação de vulnerabilidade,\n\t\t\t\tconforme regulamento.” (NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 106. (VETADO). ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 107. A Lei nº\n\t\t\t\t9.029, de 13 de abril de 1995 , passa a vigorar com as seguintes\n\t\t\t\talterações: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1º É proibida a adoção de qualquer prática\n\t\t\t\tdiscriminatória e limitativa para efeito de acesso à relação de\n\t\t\t\ttrabalho, ou de sua manutenção, por motivo de sexo, origem, raça, cor,\n\t\t\t\testado civil, situação familiar, deficiência, reabilitação profissional,\n\t\t\t\tidade, entre outros, ressalvadas, nesse caso, as hipóteses de proteção à\n\t\t\t\tcriança e ao adolescente previstas no inciso XXXIII do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 7º da\n\t\t\t\tConstituição Federal. ” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 3º Sem prejuízo do prescrito no ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art.\n\t\t\t\t2º desta Lei e nos dispositivos legais que tipificam os crimes\n\t\t\t\tresultantes de preconceito de etnia, raça, cor ou deficiência, as\n\t\t\t\tinfrações ao disposto nesta Lei são passíveis das seguintes cominações:\n\t\t\t\t..................................................................................”\n\t\t\t\t(NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 4º\n\t\t\t\t........................................................................\n\t\t\t\tI - a reintegração com ressarcimento integral de todo o período de\n\t\t\t\tafastamento, mediante pagamento das remunerações devidas, corrigidas\n\t\t\t\tmonetariamente e acrescidas de juros legais;\n\t\t\t\t....................................................................................”\n\t\t\t\t(NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 108. O ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 35 da Lei nº 9.250, de 26 de dezembro de 1995 ,\n\t\t\t\tpassa a vigorar acrescido do seguinte § 5º : “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 35.\n\t\t\t\t......................................................................\n\t\t\t\t.............................................................................................\n\t\t\t\t§ 5º Sem prejuízo do disposto no inciso IX do parágrafo único do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 3º\n\t\t\t\tda Lei nº 10.741, de 1º de outubro de 2003 , a pessoa com deficiência,\n\t\t\t\tou o contribuinte que tenha dependente nessa condição, tem preferência\n\t\t\t\tna restituição referida no inciso III do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 4º e na alínea “c” do\n\t\t\t\tinciso II do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("art. 8º .” (NR) ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 109. A Lei nº 9.503, de 23 de setembro\n\t\t\t\tde 1997 (Código de Trânsito Brasileiro) , passa a vigorar com as\n\t\t\t\tseguintes alterações: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 2º\n\t\t\t\t........................................................... Parágrafo\n\t\t\t\túnico. Para os efeitos deste Código, são consideradas vias terrestres as\n\t\t\t\tpraias abertas à circulação pública, as vias internas pertencentes aos\n\t\t\t\tcondomínios constituídos por unidades autônomas e as vias e áreas de\n\t\t\t\testacionamento de estabelecimentos privados de uso coletivo.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t86-A. As vagas de estacionamento regulamentado de que trata o inciso\n\t\t\t\tXVII do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 181 desta Lei deverão ser sinalizadas com as respectivas\n\t\t\t\tplacas indicativas de destinação e com placas informando os dados sobre\n\t\t\t\ta infração por estacionamento indevido.” “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 147-A. Ao candidato com\n\t\t\t\tdeficiência auditiva é assegurada acessibilidade de comunicação,\n\t\t\t\tmediante emprego de tecnologias assistivas ou de ajudas técnicas em\n\t\t\t\ttodas as etapas do processo de habilitação. § 1º O material didático\n\t\t\t\taudiovisual utilizado em aulas teóricas dos cursos que precedem os\n\t\t\t\texames previstos no "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 147 desta Lei deve ser acessível, por meio de\n\t\t\t\tsubtitulação com legenda oculta associada à tradução simultânea em\n\t\t\t\tLibras. § 2º É assegurado também ao candidato com deficiência auditiva\n\t\t\t\trequerer, no ato de sua inscrição, os serviços de intérprete da Libras,\n\t\t\t\tpara acompanhamento em aulas práticas e teóricas.” “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 154. (VETADO).”\n\t\t\t\t“")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 181.\n\t\t\t\t...................................................................\n\t\t\t\t..........................................................................................\n\t\t\t\tXVII -\n\t\t\t\t.........................................................................\n\t\t\t\tInfração - grave;\n\t\t\t\t.................................................................................”\n\t\t\t\t(NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 110. O inciso VI e o § 1º do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 56 da Lei nº 9.615, de 24 de\n\t\t\t\tmarço de 1998 , passam a vigorar com a seguinte redação: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 56.\n\t\t\t\t....................................................................\n\t\t\t\t...........................................................................................\n\t\t\t\tVI - 2,7% (dois inteiros e sete décimos por cento) da arrecadação bruta\n\t\t\t\tdos concursos de prognósticos e loterias federais e similares cuja\n\t\t\t\trealização estiver sujeita a autorização federal, deduzindo-se esse\n\t\t\t\tvalor do montante destinado aos prêmios;\n\t\t\t\t.............................................................................................\n\t\t\t\t§ 1º Do total de recursos financeiros resultantes do percentual de que\n\t\t\t\ttrata o inciso VI do caput , 62,96% (sessenta e dois inteiros e noventa\n\t\t\t\te seis centésimos por cento) serão destinados ao Comitê Olímpico\n\t\t\t\tBrasileiro (COB) e 37,04% (trinta e sete inteiros e quatro centésimos\n\t\t\t\tpor cento) ao Comitê Paralímpico Brasileiro (CPB), devendo ser\n\t\t\t\tobservado, em ambos os casos, o conjunto de normas aplicáveis à\n\t\t\t\tcelebração de convênios pela União.\n\t\t\t\t..................................................................................”\n\t\t\t\t(NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 111. O ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 1º da Lei nº 10.048, de 8 de novembro de 2000 ,\n\t\t\t\tpassa a vigorar com a seguinte redação: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1º As pessoas com\n\t\t\t\tdeficiência, os idosos com idade igual ou superior a 60 (sessenta) anos,\n\t\t\t\tas gestantes, as lactantes, as pessoas com crianças de colo e os obesos\n\t\t\t\tterão atendimento prioritário, nos termos desta Lei.” (NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 112. A\n\t\t\t\tLei nº 10.098, de 19 de dezembro de 2000 , passa a vigorar com as\n\t\t\t\tseguintes alterações: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 2º\n\t\t\t\t.......................................................................\n\t\t\t\tI - acessibilidade: possibilidade e condição de alcance para utilização,\n\t\t\t\tcom segurança e autonomia, de espaços, mobiliários, equipamentos\n\t\t\t\turbanos, edificações, transportes, informação e comunicação, inclusive\n\t\t\t\tseus sistemas e tecnologias, bem como de outros serviços e instalações\n\t\t\t\tabertos ao público, de uso público ou privados de uso coletivo, tanto na\n\t\t\t\tzona urbana como na rural, por pessoa com deficiência ou com mobilidade\n\t\t\t\treduzida;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - barreiras: qualquer entrave, obstáculo, atitude ou\n\t\t\t\tcomportamento que limite ou impeça a participação social da pessoa, bem\n\t\t\t\tcomo o gozo, a fruição e o exercício de seus direitos à acessibilidade,\n\t\t\t\tà liberdade de movimento e de expressão, à comunicação, ao acesso à\n\t\t\t\tinformação, à compreensão, à circulação com segurança, entre outros,\n\t\t\t\tclassificadas em: a) barreiras urbanísticas: as existentes nas vias e\n\t\t\t\tnos espaços públicos e privados abertos ao público ou de uso coletivo;\n\t\t\t\tb) barreiras arquitetônicas: as existentes nos edifícios públicos e\n\t\t\t\tprivados; c) barreiras nos transportes: as existentes nos sistemas e\n\t\t\t\tmeios de transportes; d) barreiras nas comunicações e na informação:\n\t\t\t\tqualquer entrave, obstáculo, atitude ou comportamento que dificulte ou\n\t\t\t\timpossibilite a expressão ou o recebimento de mensagens e de informações\n\t\t\t\tpor intermédio de sistemas de comunicação e de tecnologia da informação;\n\t\t\t\tIII - pessoa com deficiência: aquela que tem impedimento de longo prazo\n\t\t\t\tde natureza física, mental, intelectual ou sensorial, o qual, em\n\t\t\t\tinteração com uma ou mais barreiras, pode obstruir sua participação\n\t\t\t\tplena e efetiva na sociedade em igualdade de condições com as demais\n\t\t\t\tpessoas;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - pessoa com mobilidade reduzida: aquela que tenha, por\n\t\t\t\tqualquer motivo, dificuldade de movimentação, permanente ou temporária,\n\t\t\t\tgerando redução efetiva da mobilidade, da flexibilidade, da coordenação\n\t\t\t\tmotora ou da percepção, incluindo idoso, gestante, lactante, pessoa com\n\t\t\t\tcriança de colo e obeso;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " V - acompanhante: aquele que acompanha a pessoa\n\t\t\t\tcom deficiência, podendo ou não desempenhar as funções de atendente\n\t\t\t\tpessoal;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VI - elemento de urbanização: quaisquer componentes de obras de\n\t\t\t\turbanização, tais como os referentes a pavimentação, saneamento,\n\t\t\t\tencanamento para esgotos, distribuição de energia elétrica e de gás,\n\t\t\t\tiluminação pública, serviços de comunicação, abastecimento e\n\t\t\t\tdistribuição de água, paisagismo e os que materializam as indicações do\n\t\t\t\tplanejamento urbanístico;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VII - mobiliário urbano: conjunto de objetos\n\t\t\t\texistentes nas vias e nos espaços públicos, superpostos ou adicionados\n\t\t\t\taos elementos de urbanização ou de edificação, de forma que sua\n\t\t\t\tmodificação ou seu traslado não provoque alterações substanciais nesses\n\t\t\t\telementos, tais como semáforos, postes de sinalização e similares,\n\t\t\t\tterminais e pontos de acesso coletivo às telecomunicações, fontes de\n\t\t\t\tágua, lixeiras, toldos, marquises, bancos, quiosques e quaisquer outros\n\t\t\t\tde natureza análoga;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VIII - tecnologia assistiva ou ajuda técnica:\n\t\t\t\tprodutos, equipamentos, dispositivos, recursos, metodologias,\n\t\t\t\testratégias, práticas e serviços que objetivem promover a\n\t\t\t\tfuncionalidade, relacionada à atividade e à participação da pessoa com\n\t\t\t\tdeficiência ou com mobilidade reduzida, visando à sua autonomia,\n\t\t\t\tindependência, qualidade de vida e inclusão social;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IX - comunicação:\n\t\t\t\tforma de interação dos cidadãos que abrange, entre outras opções, as\n\t\t\t\tlínguas, inclusive a Língua Brasileira de Sinais (Libras), a\n\t\t\t\tvisualização de textos, o Braille, o sistema de sinalização ou de\n\t\t\t\tcomunicação tátil, os caracteres ampliados, os dispositivos multimídia,\n\t\t\t\tassim como a linguagem simples, escrita e oral, os sistemas auditivos e\n\t\t\t\tos meios de voz digitalizados e os modos, meios e formatos aumentativos\n\t\t\t\te alternativos de comunicação, incluindo as tecnologias da informação e\n\t\t\t\tdas comunicações;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " X - desenho universal: concepção de produtos,\n\t\t\t\tambientes, programas e serviços a serem usados por todas as pessoas, sem\n\t\t\t\tnecessidade de adaptação ou de projeto específico, incluindo os recursos\n\t\t\t\tde tecnologia assistiva.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 3º O planejamento e a urbanização\n\t\t\t\tdas vias públicas, dos parques e dos demais espaços de uso público\n\t\t\t\tdeverão ser concebidos e executados de forma a torná-los acessíveis para\n\t\t\t\ttodas as pessoas, inclusive para aquelas com deficiência ou com\n\t\t\t\tmobilidade reduzida. Parágrafo único. O passeio público, elemento\n\t\t\t\tobrigatório de urbanização e parte da via pública, normalmente segregado\n\t\t\t\te em nível diferente, destina-se somente à circulação de pedestres e,\n\t\t\t\tquando possível, à implantação de mobiliário urbano e de vegetação.”\n\t\t\t\t(NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 9º\n\t\t\t\t........................................................................\n\t\t\t\tParágrafo único. Os semáforos para pedestres instalados em vias públicas\n\t\t\t\tde grande circulação, ou que deem acesso aos serviços de reabilitação,\n\t\t\t\tdevem obrigatoriamente estar equipados com mecanismo que emita sinal\n\t\t\t\tsonoro suave para orientação do pedestre.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 10-A. A instalação\n\t\t\t\tde qualquer mobiliário urbano em área de circulação comum para pedestre\n\t\t\t\tque ofereça risco de acidente à pessoa com deficiência deverá ser\n\t\t\t\tindicada mediante sinalização tátil de alerta no piso, de acordo com as\n\t\t\t\tnormas técnicas pertinentes.” “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 12-A. Os centros comerciais e os\n\t\t\t\testabelecimentos congêneres devem fornecer carros e cadeiras de rodas,\n\t\t\t\tmotorizados ou não, para o atendimento da pessoa com deficiência ou com\n\t\t\t\tmobilidade reduzida.” "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 113. A Lei nº 10.257, de 10 de julho de 2001\n\t\t\t\t(Estatuto da Cidade) , passa a vigorar com as seguintes alterações:\n\t\t\t\t“"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 3º\n\t\t\t\t......................................................................\n\t\t\t\t............................................................................................\n\t\t\t\tIII - promover, por iniciativa própria e em conjunto com os Estados, o\n\t\t\t\tDistrito Federal e os Municípios, programas de construção de moradias e\n\t\t\t\tmelhoria das condições habitacionais, de saneamento básico, das\n\t\t\t\tcalçadas, dos passeios públicos, do mobiliário urbano e dos demais\n\t\t\t\tespaços de uso público;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - instituir diretrizes para desenvolvimento\n\t\t\t\turbano, inclusive habitação, saneamento básico, transporte e mobilidade\n\t\t\t\turbana, que incluam regras de acessibilidade aos locais de uso público;\n\t\t\t\t.................................................................................”\n\t\t\t\t(NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 41.\n\t\t\t\t....................................................................\n\t\t\t\t...........................................................................................\n\t\t\t\t§ 3º As cidades de que trata o caput deste artigo devem elaborar plano\n\t\t\t\tde rotas acessíveis, compatível com o plano diretor no qual está\n\t\t\t\tinserido, que disponha sobre os passeios públicos a serem implantados ou\n\t\t\t\treformados pelo poder público, com vistas a garantir acessibilidade da\n\t\t\t\tpessoa com deficiência ou com mobilidade reduzida a todas as rotas e\n\t\t\t\tvias existentes, inclusive as que concentrem os focos geradores de maior\n\t\t\t\tcirculação de pedestres, como os órgãos públicos e os locais de\n\t\t\t\tprestação de serviços públicos e privados de saúde, educação,\n\t\t\t\tassistência social, esporte, cultura, correios e telégrafos, bancos,\n\t\t\t\tentre outros, sempre que possível de maneira integrada com os sistemas\n\t\t\t\tde transporte coletivo de passageiros.” (NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 114. A Lei nº 10.406,\n\t\t\t\tde 10 de janeiro de 2002 (Código Civil) , passa a vigorar com as\n\t\t\t\tseguintes alterações: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 3º São absolutamente incapazes de exercer\n\t\t\t\tpessoalmente os atos da vida civil os menores de 16 (dezesseis) anos. I\n\t\t\t\t- (Revogado);"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" II - (Revogado);")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" III - (Revogado).” (NR) “")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 4º São\n\t\t\t\tincapazes, relativamente a certos atos ou à maneira de os exercer:\n\t\t\t\t.....................................................................................\n\t\t\t\tII - os ébrios habituais e os viciados em tóxico;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - aqueles que, por\n\t\t\t\tcausa transitória ou permanente, não puderem exprimir sua vontade;\n\t\t\t\t.............................................................................................\n\t\t\t\tParágrafo único . A capacidade dos indígenas será regulada por\n\t\t\t\tlegislação especial.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 228.\n\t\t\t\t.....................................................................\n\t\t\t\t.............................................................................................\n\t\t\t\tII - (Revogado);"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - (Revogado);\n\t\t\t\t.............................................................................................\n\t\t\t\t§ 1º\n\t\t\t\t..............................................................................\n\t\t\t\t§ 2º A pessoa com deficiência poderá testemunhar em igualdade de\n\t\t\t\tcondições com as demais pessoas, sendo-lhe assegurados todos os recursos\n\t\t\t\tde tecnologia assistiva.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1.518 . Até a celebração do\n\t\t\t\tcasamento podem os pais ou tutores revogar a autorização.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t1.548.\n\t\t\t\t................................................................... I -\n\t\t\t\t(Revogado);\n\t\t\t\t....................................................................................”\n\t\t\t\t(NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1.550.\n\t\t\t\t..................................................................\n\t\t\t\t.............................................................................................\n\t\t\t\t§ 1º\n\t\t\t\t..............................................................................\n\t\t\t\t§ 2º A pessoa com deficiência mental ou intelectual em idade núbia\n\t\t\t\tpoderá contrair matrimônio, expressando sua vontade diretamente ou por\n\t\t\t\tmeio de seu responsável ou curador.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1.557.\n\t\t\t\t................................................................\n\t\t\t\t............................................................................................\n\t\t\t\tIII - a ignorância, anterior ao casamento, de defeito físico\n\t\t\t\tirremediável que não caracterize deficiência ou de moléstia grave e\n\t\t\t\ttransmissível, por contágio ou por herança, capaz de pôr em risco a\n\t\t\t\tsaúde do outro cônjuge ou de sua descendência;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" IV - (Revogado).” (NR)\n\t\t\t\t“")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1.767.\n\t\t\t\t.................................................................. I -\n\t\t\t\taqueles que, por causa transitória ou permanente, não puderem exprimir\n\t\t\t\tsua vontade;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" II - (Revogado);")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " III - os ébrios habituais e os viciados em\n\t\t\t\ttóxico;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " IV - (Revogado);\n\t\t\t\t....................................................................................”\n\t\t\t\t(NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1.768. O processo que define os termos da curatela deve ser\n\t\t\t\tpromovido:\n\t\t\t\t.............................................................................................\n\t\t\t\tIV - pela própria pessoa.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1.769 . O Ministério Público\n\t\t\t\tsomente promoverá o processo que define os termos da curatela:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " I - nos\n\t\t\t\tcasos de deficiência mental ou intelectual;\n\t\t\t\t............................................................................................\n\t\t\t\tIII - se, existindo, forem menores ou incapazes as pessoas mencionadas\n\t\t\t\tno inciso II.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1.771. Antes de se pronunciar acerca dos\n\t\t\t\ttermos da curatela, o juiz, que deverá ser assistido por equipe\n\t\t\t\tmultidisciplinar, entrevistará pessoalmente o interditando.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t1.772. O juiz determinará, segundo as potencialidades da pessoa, os\n\t\t\t\tlimites da curatela, circunscritos às restrições constantes do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art.\n\t\t\t\t1.782, e indicará curador. Parágrafo único. Para a escolha do curador, o\n\t\t\t\tjuiz levará em conta a vontade e as preferências do interditando, a\n\t\t\t\tausência de conflito de interesses e de influência indevida, a\n\t\t\t\tproporcionalidade e a adequação às circunstâncias da pessoa.” (NR) “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t1.775-A . Na nomeação de curador para a pessoa com deficiência, o juiz\n\t\t\t\tpoderá estabelecer curatela compartilhada a mais de uma pessoa.” “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t1.777. As pessoas referidas no inciso I do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 1.767 receberão todo o\n\t\t\t\tapoio necessário para ter preservado o direito à convivência familiar e\n\t\t\t\tcomunitária, sendo evitado o seu recolhimento em estabelecimento que os\n\t\t\t\tafaste desse convívio.” (NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 115. O ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nTítulo IV ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "do Livro IV da Parte\n\t\t\t\tEspecial da Lei nº 10.406, de 10 de janeiro de 2002 (Código Civil) ,\n\t\t\t\tpassa a vigorar com a seguinte redação: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nTítulo IV ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Da Tutela, da\n\t\t\t\tCuratela e da Tomada de Decisão Apoiada” "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 116. O ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("\nTítulo IV ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "do Livro\n\t\t\t\tIV da Parte Especial da Lei nº 10.406, de 10 de janeiro de 2002 (Código\n\t\t\t\tCivil) , passa a vigorar acrescido do seguinte Capítulo III: “CAPÍTULO\n\t\t\t\tIII Da Tomada de Decisão Apoiada "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1.783-A. A tomada de decisão\n\t\t\t\tapoiada é o processo pelo qual a pessoa com deficiência elege pelo menos\n\t\t\t\t2 (duas) pessoas idôneas, com as quais mantenha vínculos e que gozem de\n\t\t\t\tsua confiança, para prestar-lhe apoio na tomada de decisão sobre atos da\n\t\t\t\tvida civil, fornecendo-lhes os elementos e informações necessários para\n\t\t\t\tque possa exercer sua capacidade. § 1º Para formular pedido de tomada de\n\t\t\t\tdecisão apoiada, a pessoa com deficiência e os apoiadores devem\n\t\t\t\tapresentar termo em que constem os limites do apoio a ser oferecido e os\n\t\t\t\tcompromissos dos apoiadores, inclusive o prazo de vigência do acordo e o\n\t\t\t\trespeito à vontade, aos direitos e aos interesses da pessoa que devem\n\t\t\t\tapoiar. § 2º O pedido de tomada de decisão apoiada será requerido pela\n\t\t\t\tpessoa a ser apoiada, com indicação expressa das pessoas aptas a\n\t\t\t\tprestarem o apoio previsto no caput deste artigo. § 3º Antes de se\n\t\t\t\tpronunciar sobre o pedido de tomada de decisão apoiada, o juiz,\n\t\t\t\tassistido por equipe multidisciplinar, após oitiva do Ministério\n\t\t\t\tPúblico, ouvirá pessoalmente o requerente e as pessoas que lhe prestarão\n\t\t\t\tapoio. § 4º A decisão tomada por pessoa apoiada terá validade e efeitos\n\t\t\t\tsobre terceiros, sem restrições, desde que esteja inserida nos limites\n\t\t\t\tdo apoio acordado. § 5º Terceiro com quem a pessoa apoiada mantenha\n\t\t\t\trelação negocial pode solicitar que os apoiadores contra-assinem o\n\t\t\t\tcontrato ou acordo, especificando, por escrito, sua função em relação ao\n\t\t\t\tapoiado. § 6º Em caso de negócio jurídico que possa trazer risco ou\n\t\t\t\tprejuízo relevante, havendo divergência de opiniões entre a pessoa\n\t\t\t\tapoiada e um dos apoiadores, deverá o juiz, ouvido o Ministério Público,\n\t\t\t\tdecidir sobre a questão. § 7º Se o apoiador agir com negligência,\n\t\t\t\texercer pressão indevida ou não adimplir as obrigações assumidas, poderá\n\t\t\t\ta pessoa apoiada ou qualquer pessoa apresentar denúncia ao Ministério\n\t\t\t\tPúblico ou ao juiz. § 8º Se procedente a denúncia, o juiz destituirá o\n\t\t\t\tapoiador e nomeará, ouvida a pessoa apoiada e se for de seu interesse,\n\t\t\t\toutra pessoa para prestação de apoio. § 9º A pessoa apoiada pode, a\n\t\t\t\tqualquer tempo, solicitar o término de acordo firmado em processo de\n\t\t\t\ttomada de decisão apoiada. § 10. O apoiador pode solicitar ao juiz a\n\t\t\t\texclusão de sua participação do processo de tomada de decisão apoiada,\n\t\t\t\tsendo seu desligamento condicionado à manifestação do juiz sobre a\n\t\t\t\tmatéria. § 11. Aplicam-se à tomada de decisão apoiada, no que couber, as\n\t\t\t\tdisposições referentes à prestação de contas na curatela.” "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 117. O\n\t\t\t\t")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 1º da Lei nº 11.126, de 27 de junho de 2005 , passa a vigorar com a\n\t\t\t\tseguinte redação: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 1º É assegurado à pessoa com deficiência visual\n\t\t\t\tacompanhada de cão-guia o direito de ingressar e de permanecer com o\n\t\t\t\tanimal em todos os meios de transporte e em estabelecimentos abertos ao\n\t\t\t\tpúblico, de uso público e privados de uso coletivo, desde que observadas\n\t\t\t\tas condições impostas por esta Lei.\n\t\t\t\t.............................................................................................\n\t\t\t\t§ 2º O disposto no caput deste artigo aplica-se a todas as modalidades e\n\t\t\t\tjurisdições do serviço de transporte coletivo de passageiros, inclusive\n\t\t\t\tem esfera internacional com origem no território brasileiro.” (NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art.\n\t\t\t\t118. O inciso IV do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 46 da Lei nº 11.904, de 14 de janeiro de 2009 ,\n\t\t\t\tpassa a vigorar acrescido da seguinte alínea “k”: “"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 46.\n\t\t\t\t......................................................................\n\t\t\t\t...........................................................................................\n\t\t\t\tIV -\n\t\t\t\t..............................................................................\n\t\t\t\t...........................................................................................\n\t\t\t\tk) de acessibilidade a todas as pessoas.\n\t\t\t\t.................................................................................”\n\t\t\t\t(NR) "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 119. A Lei nº 12.587, de 3 de janeiro de 2012 , passa a\n\t\t\t\tvigorar acrescida do seguinte "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("art. 12-B: “")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 12-B. Na outorga de\n\t\t\t\texploração de serviço de táxi, reservar-se-ão 10% (dez por cento) das\n\t\t\t\tvagas para condutores com deficiência. § 1º Para concorrer às vagas\n\t\t\t\treservadas na forma do caput deste artigo, o condutor com deficiência\n\t\t\t\tdeverá observar os seguintes requisitos quanto ao veículo utilizado: I -\n\t\t\t\tser de sua propriedade e por ele conduzido; e"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " II - estar adaptado às\n\t\t\t\tsuas necessidades, nos termos da legislação vigente. § 2º No caso de não\n\t\t\t\tpreenchimento das vagas na forma estabelecida no caput deste artigo, as\n\t\t\t\tremanescentes devem ser disponibilizadas para os demais concorrentes.”\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 120. Cabe aos órgãos competentes, em cada esfera de governo, a\n\t\t\t\telaboração de relatórios circunstanciados sobre o cumprimento dos prazos\n\t\t\t\testabelecidos por força das Leis nº 10.048, de 8 de novembro de 2000 , e\n\t\t\t\tnº 10.098, de 19 de dezembro de 2000 , bem como o seu encaminhamento ao\n\t\t\t\tMinistério Público e aos órgãos de regulação para adoção das\n\t\t\t\tprovidências cabíveis. Parágrafo único. Os relatórios a que se refere o\n\t\t\t\tcaput deste artigo deverão ser apresentados no prazo de 1 (um) ano a\n\t\t\t\tcontar da entrada em vigor desta Lei. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 121. Os direitos, os prazos e\n\t\t\t\tas obrigações previstos nesta Lei não excluem os já estabelecidos em\n\t\t\t\toutras legislações, inclusive em pactos, tratados, convenções e\n\t\t\t\tdeclarações internacionais aprovados e promulgados pelo Congresso\n\t\t\t\tNacional, e devem ser aplicados em conformidade com as demais normas\n\t\t\t\tinternas e acordos internacionais vinculantes sobre a matéria. Parágrafo\n\t\t\t\túnico. Prevalecerá a norma mais benéfica à pessoa com deficiência. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art.\n\t\t\t\t122. Regulamento disporá sobre a adequação do disposto nesta Lei ao\n\t\t\t\ttratamento diferenciado, simplificado e favorecido a ser dispensado às\n\t\t\t\tmicroempresas e às empresas de pequeno porte, previsto no § 3º do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art.\n\t\t\t\t1º da Lei Complementar nº 123, de 14 de dezembro de 2006 . "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 123.\n\t\t\t\tRevogam-se os seguintes dispositivos: (Vigência)"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" I - o inciso II do § 2º\n\t\t\t\tdo ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 1º da Lei nº 9.008, de 21 de março de 1995 ;"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" II - os incisos I,\n\t\t\t\tII e III do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 3º da Lei nº 10.406, de 10 de janeiro de 2002 (Código\n\t\t\t\tCivil);"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" III - os incisos II e III do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 228 da Lei nº 10.406, de 10 de\n\t\t\t\tjaneiro de 2002 (Código Civil);"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" IV - o inciso I do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 1.548 da Lei nº\n\t\t\t\t10.406, de 10 de janeiro de 2002 (Código Civil);"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" V - o inciso IV do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art.\n\t\t\t\t1.557 da Lei nº 10.406, de 10 de janeiro de 2002 (Código Civil);"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" VI - os\n\t\t\t\tincisos II e IV do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 1.767 da Lei nº 10.406, de 10 de janeiro de 2002\n\t\t\t\t(Código Civil);"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        " VII - os arts. 1.776 e 1.780 da Lei nº 10.406, de 10 de\n\t\t\t\tjaneiro de 2002 (Código Civil). "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("Art. 124. O § 1º do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 2º desta Lei\n\t\t\t\tdeverá entrar em vigor em até 2 (dois) anos, contados da entrada em\n\t\t\t\tvigor desta Lei. "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 125. Devem ser observados os prazos a seguir\n\t\t\t\tdiscriminados, a partir da entrada em vigor desta Lei, para o\n\t\t\t\tcumprimento dos seguintes dispositivos:"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" I - incisos I e II do § 2º do\n\t\t\t\t")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("art. 28 , 48 (quarenta e oito) meses;")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" II - § 6º do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("art. 44 , 48\n\t\t\t\t(quarenta e oito) meses;")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" II - § 6º do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 44, 60 (sessenta) meses;\n\t\t\t\t(Redação dada pela Medida Provisória nº 917, de 2019)"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" II - § 6º do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art.\n\t\t\t\t44, 60 (sessenta) meses; (Redação dada pela Lei nº 14.009, de 2020) II -\n\t\t\t\t§ 6º do "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 44, 84 (oitenta e quatro) meses; (Redação dada pela Medida\n\t\t\t\tProvisória nº 1.025, de 2020)"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" II - § 6º do ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "art. 44, 84 (oitenta e\n\t\t\t\tquatro) meses; (Redação dada pela Lei nº 14.159, de 2021)"
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" III - ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("art. 45\n\t\t\t\t, 24 (vinte e quatro) meses;")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(" IV - ")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("art. 49 , 48 (quarenta e oito) meses.\n\t\t\t\t")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 126. Prorroga-se até 31 de dezembro de 2021 a vigência da Lei nº\n\t\t\t\t8.989, de 24 de fevereiro de 1995 . "
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Art. 127. Esta Lei entra em vigor\n\t\t\t\tapós decorridos 180 (cento e oitenta) dias de sua publicação oficial ."
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Brasília, 6 de julho de 2015; 194º da Independência e 127º da República."
                      )
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v("DILMA ROUSSEF "),
                      _c("br"),
                      _vm._v("\n\t\t\t\tMarivaldo de Castro Pereira "),
                      _c("br"),
                      _vm._v("\n\t\t\t\tJoaquim Vieira Ferreira Levy"),
                      _c("br"),
                      _vm._v("\n\t\t\t\tRenato Janine Ribeiro "),
                      _c("br"),
                      _vm._v("\n\t\t\t\tArmando Monteiro "),
                      _c("br"),
                      _vm._v("\n\t\t\t\tNelson Barbosa "),
                      _c("br"),
                      _vm._v("\n\t\t\t\tGilberto Kassab"),
                      _c("br"),
                      _vm._v("\n\t\t\t\tLuis Inácio Lucena Adams "),
                      _c("br"),
                      _vm._v("\n\t\t\t\tGilberto José Spier Vargas "),
                      _c("br"),
                      _vm._v("\n\t\t\t\tGuilherme Afif Domingos")
                    ])
                  ]),
                  _c("b-form-group", { staticClass: "text-label" }, [
                    _c("label", { attrs: { tabindex: "0" } }, [
                      _vm._v(
                        "Este texto não substitui o publicado no DOU de 7.7.2015 *"
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { align: "right" } },
        [
          _c(
            "b-col",
            { attrs: { xl: "6" } },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    outline: "",
                    size: "md",
                    variant: "secondary",
                    title: "Voltar para tela inicial"
                  },
                  on: {
                    click: function($event) {
                      return _vm.voltar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fas fa-arrow-left" }),
                  _vm._v(" Voltar\n\t\t\t\t")
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }